import {
  makeStyles,
  Theme,
  BottomNavigation,
  BottomNavigationAction,
} from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import {
  Fonts,
  ExploreIcon,
  CameraIcon,
  AccountIcon,
  IconButton,
  RenewalEventmapIcon,
  Typography,
  ZoomPanel,
  Modal,
} from '@thingsw/pitta-design-system';
import clsx from 'clsx';
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../features/store';
import {
  changeDirection,
  setFontFamily,
  THEME,
} from '../../../features/Theme/slice';
import { useTranslation } from 'react-i18next';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import { MapboxLocationMapWrapper } from '../../../components/maps/MapboxLocationMapWrapper';
import ListIcon from '@material-ui/icons/List';
import { detect } from 'detect-browser';
import {
  AppBackReason,
  AvailableFws,
  createPermissions,
  disableRotate,
  getFirmwareConfig,
  getPlanFromServiceID,
  ICameraInfo,
  Languages,
  LightColors,
  SemanticDarkColors,
} from '@thingsw/pitta-modules';
import {
  CAMERA,
  clearPublicCamera,
  loadCameras,
  loadFirmwareInfos,
} from '../../../features/Camera/slice';
import { initGPSWs, LOCATION_WS } from '../../../features/LocationWS/slice';
import {
  loadUsageInfo,
  loadUserNotification,
  loadUserPermissions,
  loadUserProfile,
  successLoadUserSettings,
  USER,
} from '../../../features/User/slice';
import { DRAWER_MODE, MobileDrawer } from '../../../components/MobileDrawer';
import _ from 'lodash';
import { RenewalCameraItem } from '../../../components/renewal2/RenewalCameraItem';
import { loadSubscription, PAYMENT } from '../../../features/Payment/slice';
import { RenewalMobileCameraMenu } from '../../../components/renewal2/RenewalMobileCameraMenu';
import { findNewFw } from '../../../utils/Firmware';
import { TopRightControl, useQuery } from '@thingsw/pitta-liveview-module';
import { getCamInfo } from '../../../apis';
import { LiveViewMapboxModal } from '../../../components/uxui/LiveViewMapboxModal';
import { setRemovePlayer } from '../../../features/LiveView/slice';
import ErrorIcon from '@material-ui/icons/Error';
import { setPermission } from '../../../features/Permission/slice';
import {
  clearEvent,
  disconnectWebPush,
  loadPushToken,
  PUSH_EVENT,
  setWebPushEvent,
} from '../../../features/PushEvent/slice';
import { PublicCamInfoToast } from '../../../components/PublicCamInfoToast';

export type APP_MENU =
  | 'PLAYBACK'
  | 'LIVEVIEW'
  | 'NOTIFICATIONS'
  | 'CLOUD_STORAGE'
  | 'REPORT'
  | 'GPS_TRACKING'
  | 'BATTERY'
  | 'CONNECT_DASHCAM_LOCALLY'
  | 'CLOUD_CONNECTION_SETTING'
  | 'CAMERA_PROFILE'
  | 'CAMERA_SETTING'
  | 'FORMAT_SD_CARD'
  | 'REMOTE_FIRMWARE_UPDATE'
  | 'DELETE_CAMERA'
  | 'REBOOT_CAMERA'
  | 'UNPAIR_BATTERY';

export interface OPEN_APP_MENU {
  psn?: string;
  menu: APP_MENU;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionRoot: {
      color: (props: any) => props.colors.primary['3'],
    },
    actionSelected: {
      color: (props: any) => `${props.colors.primary['1']}!important`,
      fontWeight: 500,
    },
    //@ts-ignore
    actionLabel: {
      ...Fonts.Default.Caption,
      whiteSpace: 'nowrap',
      fontSize: '10.5px !important',
      marginTop: 1,
    },
    footerMenuDiv: {
      position: 'fixed',
      width: '100%',
      bottom: 0,
      borderTop: (props: any) => `1px solid ${props.colors.primary['5']}`,

      backgroundColor: (props: any) => props.colors.primary['0'],
      zIndex: 99,
    },
    iconBtn: {
      width: 44,
      height: 36,
      color: (props: any) => props.colors.primary['1'],
      '&:hover': {
        color: (props: any) => props.colors.primary['1'],
      },
    },
    activeIconBtn: {
      borderRadius: 7,
      color: (props: any) => props.colors.primary['0'],
      backgroundColor: (props: any) => props.colors.primary['7'],
      boxShadow:
        '0px 0px 1px rgba(0, 0, 0, 0.14), 0px 1px 1px rgba(0, 0, 0, 0.12), 0px 0px 3px rgba(0, 0, 0, 0.2)',
      '&:hover': {
        backgroundColor: (props: any) => props.colors.primary['7'],
        color: (props: any) => props.colors.primary['0'],
      },
    },
    toastDiv: {
      position: 'absolute',
      bottom: -20,
      right: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      transition: theme.transitions.create(['bottom']),
    },
    toast: {
      width: 345,
      padding: '9px 16px',
      boxShadow:
        '0px 0px 3px 0px #00000033, 0px 1px 1px 0px #0000001F,0px 0px 1px 0px #00000024',

      borderRadius: 8,
    },
    toastOpen: {
      bottom: 110,
      zIndex: 9999,
    },
    modalHeadingText: {
      color: (props: any) => props.colors.primary['1'],
    },
    iosModalContent: {
      paddingTop: 8,
    },
    modalTitle: {
      minHeight: 24,
    },
    modalLButton: {
      backgroundColor: (props: any) =>
        props.color === 'dark'
          ? SemanticDarkColors.primary['0']
          : props.colors.primary['0'],
      color: (props: any) => props.colors.primary['1'],
      border: (props: any) => `1px solid ${props.colors.primary['4']}`,
      '&:hover': {
        backgroundColor: (props: any) =>
          props.color === 'dark'
            ? SemanticDarkColors.primary['0']
            : props.colors.primary['0'],
        color: (props: any) => props.colors.primary['1'],
        border: (props: any) => `1px solid ${props.colors.primary['4']}`,
      },
      '&:active': {
        backgroundColor: (props: any) =>
          props.color === 'dark'
            ? SemanticDarkColors.primary['0']
            : props.colors.primary['0'],
        color: (props: any) => props.colors.primary['1'],
        border: (props: any) => `1px solid ${props.colors.primary['4']}`,
      },
    },
  })
);

export const RenewalMapviewScreen = () => {
  const themeState = useSelector((state: RootState) => state[THEME]);
  const { colors, color } = themeState;
  const classes = useStyles({ colors, color });
  const { i18n, t } = useTranslation();
  const dispatch = useDispatch();
  const query = useQuery();

  const { webPushEvent } = useSelector((state: RootState) => state[PUSH_EVENT]);

  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const countRef = useRef(0);

  const [wifiBatteryList, setWifiBatteryList] = useState<
    {
      psn: string;
      percent: number;
      time: number;
    }[]
  >([]);

  useEffect(() => {
    let lang = query.get('lang');
    if (!_.includes(_.keys(Languages), lang)) {
      lang = 'en';
    }
    switch (lang) {
      case 'ar':
        i18n.changeLanguage('ar');
        dispatch(changeDirection('rtl'));
        dispatch(setFontFamily('Noto Naskh Arabic UI'));
        break;
      case 'de':
      case 'es':
      case 'fi':
      case 'fr':
      case 'id':
      case 'it':
      case 'nb':
      case 'nl':
      case 'pl':
      case 'ru':
      case 'uk':
      case 'vi':
        i18n.changeLanguage(lang);
        dispatch(setFontFamily('Roboto'));
        break;
      case 'th':
        i18n.changeLanguage(lang);
        dispatch(setFontFamily('Noto Sans Thai UI'));
        break;
      case 'ja':
        i18n.changeLanguage(lang);
        dispatch(setFontFamily('Noto Sans JP'));
        break;
      case 'ko':
        i18n.changeLanguage(lang);
        dispatch(setFontFamily('Noto Sans KR'));
        break;
      case 'zh':
      case 'sc':
        i18n.changeLanguage('sc');
        dispatch(setFontFamily('Noto Sans SC'));
        break;
      case 'tc':
        i18n.changeLanguage('tc');
        dispatch(setFontFamily('Noto Sans TC'));
        break;
      default:
        i18n.changeLanguage('en');
        dispatch(setFontFamily('Roboto'));
    }
  }, [dispatch, i18n, query]);

  const {
    email,
    loginInfo,
    userProfile,
    permissions: perm,
    tokenType,
    userNotification,
  } = useSelector((state: RootState) => state[USER]);

  const { cameraList, firmwares, publicCamera } = useSelector(
    (state: RootState) => state[CAMERA]
  );

  const { gpsWsReadyState } = useSelector(
    (state: RootState) => state[LOCATION_WS]
  );
  const { subscriptionInfo } = useSelector(
    (state: RootState) => state[PAYMENT]
  );

  // const {
  //   email,
  //   loginInfo,
  //   userNotification,
  // } = useSelector((state: RootState) => state[USER]);

  const [value] = React.useState(1);
  const [planName, setPlanName] = useState<string>();
  const [openMoreMenu, setOpenMoreMenu] = useState(false);
  const [moreCamera, setMoreCamera] = useState<ICameraInfo>();
  const [availableNewFws, setAvailableNewFws] = useState<AvailableFws>({});
  const [visibleGuide, setVisibleGuide] = useState(true);
  const [focusCam, setFocusCam] = useState<ICameraInfo>();
  const [drawMode, setDrawMode] = useState<DRAWER_MODE>('renewal-camera');
  const [openDisconnectedModal, setOpenDisconnectedModal] = useState(false);
  const [openNotLoginModal, setOpenNotLoginModal] = useState(false);
  const [openNoGPSModal, setOpenNoGPSModal] = useState(false);
  const [liveCam, setLiveCam] = useState<ICameraInfo>();
  const [openLiveModal, setOpenLiveModal] = useState(false);
  const mapRef = useRef<HTMLDivElement>(null);

  const [openNoLocPermIOSModal, setOpenNoLocPermIOSModal] = useState(false);
  const [openNoLocPermModal, setOpenNoLocPermModal] = useState(false);
  // 0: 권한 없음, 1: 권한 있음
  const [locPerm, setLocPerm] = useState<number>();

  const [liveCams, setLiveCams] = useState<ICameraInfo[]>([]);

  const [infoOpen, setInfoOpen] = useState(true);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setInfoOpen(false);
    }, 3000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);

  const withCloudCameras = useMemo(() => {
    const withList = query.get('list') !== 'false';
    return (cameraList?.deviceCount ?? 0) > 0 && withList;
  }, [cameraList?.deviceCount, query]);

  const browser = useMemo(() => {
    return detect();
  }, []);

  //@ts-ignore
  window.setPushEvent = useCallback(
    (pushEvent: string) => {
      dispatch(setWebPushEvent(JSON.parse(pushEvent)));
    },
    [dispatch]
  );

  useEffect(() => {
    let speedUnit = query.get('speed_unit') ?? '0';

    dispatch(
      successLoadUserSettings({
        velocityUnit: speedUnit,
        mapType: '0',
      })
    );
  }, [dispatch, query]);

  useEffect(() => {
    if (webPushEvent) {
      const timerId = setTimeout(() => dispatch(clearEvent()), 8 * 1000);
      return () => {
        clearTimeout(timerId);
      };
    }
  }, [dispatch, webPushEvent]);

  useEffect(() => {
    const pushNotification = query.get('push') === 'true';
    console.log(
      'userNotification',
      userNotification,
      'email',
      email,
      'loginInfo',
      loginInfo,
      'pushNotification',
      pushNotification
    );
    if (email && (userNotification || userNotification === null) && loginInfo) {
      if (userNotification?.device_alarm === 'on' || pushNotification) {
        dispatch(loadPushToken(email));

        return () => {
          console.log('disconnectWebPush');
          dispatch(disconnectWebPush());
        };
      } else {
        console.log('disconnectWebPush');
        dispatch(disconnectWebPush());
      }
    }
  }, [dispatch, email, loginInfo, query, userNotification]);

  useEffect(() => {
    if (
      subscriptionInfo?.servicePlanName &&
      (subscriptionInfo?.servicePlanName === 'free' ||
        subscriptionInfo?.servicePlanName.indexOf('lite') > -1)
    ) {
      dispatch(loadUsageInfo());
    }
  }, [dispatch, subscriptionInfo?.servicePlanName]);

  useEffect(() => {
    setLiveCam(publicCamera);
  }, [publicCamera]);

  const requestWifiBatteryInfo = useCallback(() => {
    if (browser?.name === 'ios-webview') {
      //@ts-ignore
      return webkit.messageHandlers.updateWifiBattery.postMessage({});
    }
    if (
      browser?.name === 'chromium-webview' &&
      //@ts-ignore
      window.Webviewer?.updateWifiBattery
    ) {
      //@ts-ignore
      window.Webviewer?.updateWifiBattery();
    }
  }, [browser?.name]);

  // 로딩 후 Wifi 배터리 정보 요청
  useEffect(() => {
    requestWifiBatteryInfo();
  }, [requestWifiBatteryInfo]);

  useEffect(() => {
    if (document && window) {
      document.addEventListener('visibilitychange', requestWifiBatteryInfo);
      window.addEventListener('focus', requestWifiBatteryInfo);
    }

    return () => {
      document.removeEventListener('visibilitychange', requestWifiBatteryInfo);
      window.removeEventListener('focus', requestWifiBatteryInfo);
    };
  }, [requestWifiBatteryInfo]);

  const handleMenu = useCallback(
    (menu: APP_MENU, camera?: ICameraInfo) => {
      const msg: OPEN_APP_MENU = {
        menu: menu,
        psn: camera?.psn,
      };
      console.log('handleMenu', 'msng', msg);

      if (msg.menu === 'UNPAIR_BATTERY') {
        intervalRef.current = setInterval(() => {
          setWifiBatteryList([]);
          requestWifiBatteryInfo();
        }, 2000);

        countRef.current++;

        if (countRef.current > 10) {
          clearInterval(intervalRef.current!);
          countRef.current = 0;
        }
      }
      if (browser?.name === 'ios-webview') {
        //@ts-ignore
        return webkit.messageHandlers.openMenu.postMessage(msg);
      }
      if (browser?.name === 'chromium-webview') {
        //@ts-ignore
        window.Webviewer?.openMenu(JSON.stringify(msg));
      }
    },
    [browser?.name, requestWifiBatteryInfo]
  );

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      countRef.current = 0;
      setWifiBatteryList([]);
    };
  }, []);

  // useEffect(() => {
  //   if (drawMode === "half" || drawMode === "open") {
  //     dispatch(loadCameras());
  //   }
  // }, [dispatch, drawMode]);

  //@ts-ignore
  window.requestCloseDrawer = useCallback(() => {
    console.log('requestCloseDrawer');
    setTimeout(() => {
      dispatch(loadCameras());
    }, 100);
    setDrawMode('close');
  }, [dispatch]);

  //@ts-ignore
  window.requestUpdateList = useCallback(() => {
    console.log('requestUpdateList');
    dispatch(loadCameras());
  }, [dispatch]);

  //@ts-ignore
  window.updateLocationPerm = useCallback((perm: number) => {
    console.log('updateLocationPerm', perm);
    setLocPerm(perm);
  }, []);

  //@ts-ignore
  window.updateWifiBattery = useCallback((data: string) => {
    console.log('receiveBatteryData', data);

    const parseData = JSON.parse(data) as {
      psn: string;
      percent: number;
      time: number;
    }[];

    console.log('parseData', parseData);

    setWifiBatteryList(parseData);
  }, []);

  useEffect(() => {
    dispatch(loadCameras());
    const interval = setInterval(() => {
      dispatch(loadCameras());
    }, 30 * 1000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch]);

  useEffect(() => {
    if (cameraList) {
      setAvailableNewFws(
        _.reduce(
          cameraList.deviceListInfo,
          (result, dev) => {
            return {
              ...result,
              [dev.device.psn]: findNewFw(dev.device, firmwares),
            };
          },
          {}
        )
      );
    }
  }, [cameraList, firmwares]);

  useEffect(() => {
    dispatch(loadUserProfile());
    dispatch(loadUserPermissions());
    dispatch(loadFirmwareInfos());
    dispatch(loadSubscription());
    dispatch(loadUserNotification());
  }, [dispatch]);

  useEffect(() => {
    if (subscriptionInfo) {
      setPlanName(getPlanFromServiceID(subscriptionInfo.servicePlanID));
    }
  }, [subscriptionInfo]);

  const permissions = useMemo(() => {
    console.log({
      userProfile,
      perm,
      subscriptionInfo,
      planName,
    });
    return createPermissions({
      userProfile,
      perm,
      subscriptionInfo,
      planName,
    });
  }, [perm, planName, subscriptionInfo, userProfile]);

  useEffect(() => {
    dispatch(setPermission(permissions));
  }, [dispatch, permissions]);

  // Cloud Native 2차 대시캠 위치 얻어오는 websocket 처리
  useEffect(() => {
    console.log('GPS_WS', 'initGPSWs', loginInfo, email, gpsWsReadyState);
    if (loginInfo && email && gpsWsReadyState === WebSocket.CLOSED) {
      console.log('GPS_WS', 'initGPSWs');
      dispatch(initGPSWs());
      const interval = setInterval(() => {
        console.log('GPS_WS', 'initGPSWs');
        dispatch(initGPSWs());
      }, 10 * 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [dispatch, email, gpsWsReadyState, loginInfo]);

  const handleBack = useCallback(
    (reason?: AppBackReason) => {
      const browser = detect();
      if (browser?.name === 'ios-webview') {
        //@ts-ignore
        return webkit.messageHandlers.back.postMessage({
          reason,
          pairingBatteryList: wifiBatteryList,
        });
      }
      if (browser?.name === 'chromium-webview') {
        //@ts-ignore
        if (window.Sim?.back) {
          //@ts-ignore
          window.Sim.back();
        }

        //@ts-ignore
        if (window.Webviewer?.back) {
          //@ts-ignore
          window.Webviewer.back(
            JSON.stringify({ reason, pairingBatteryList: wifiBatteryList })
          );
        }
      }
    },
    [wifiBatteryList]
  );

  useEffect(() => {
    const loc_perm = query.get('loc_perm');
    console.log('RenewalMapviewScreen', 'loc_perm', loc_perm);
    if (loc_perm) {
      setLocPerm(parseInt(loc_perm));
    } else {
      setLocPerm(1);
    }
  }, [query]);

  const handleFailedLocation = useCallback(() => {
    console.log('handleFailedLocation');
    const browser = detect();
    if (browser?.name === 'ios-webview') {
      if (locPerm === 1) {
        setOpenNoLocPermIOSModal(true);
      } else {
        //@ts-ignore
        webkit.messageHandlers.alert.postMessage({
          reason: 'NO_LOCATION_PERMISSION',
        });
      }
    } else if (browser?.name === 'chromium-webview') {
      //@ts-ignore
      window.Webviewer?.alert(
        JSON.stringify({ reason: 'NO_LOCATION_PERMISSION' })
      );
    } else {
      setOpenNoLocPermModal(true);
    }
  }, [locPerm]);

  const topButtonMarkup = useMemo(() => {
    return (
      <div
        style={{
          position: 'fixed',
          top: 8,
          left: 0,
          right: 0,
          zIndex: 100,
          display: 'flex',
          justifyContent: 'center',
          filter:
            'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.06)) drop-shadow(0px 6px 40px rgba(0, 0, 0, 0.05))',
        }}
      >
        <div
          style={{
            backgroundColor: colors.primary['0'],
            border: `1px solid ${colors.primary['6']}`,
            borderRadius: 9,
            padding: 2,
          }}
        >
          <IconButton
            className={classes.iconBtn}
            onClick={() => {
              handleBack('MENU_CAMERAS');
            }}
          >
            <ListIcon />
          </IconButton>
          <IconButton className={clsx(classes.iconBtn, classes.activeIconBtn)}>
            <RenewalEventmapIcon />
          </IconButton>
        </div>
      </div>
    );
  }, [classes.activeIconBtn, classes.iconBtn, colors.primary, handleBack]);

  const guideMarkup = useMemo(() => {
    const showGuide = query.get('guide') === 'true';
    return (
      showGuide &&
      visibleGuide && (
        <>
          <div
            style={{
              position: 'fixed',
              top: 0,
              bottom: 0,
              right: 0,
              left: 0,
              zIndex: 99999,
              backgroundColor: `${LightColors.primary['1']}73`,
            }}
            onClick={() => {
              setVisibleGuide(false);
            }}
          >
            <div
              style={{
                position: 'fixed',
                right: 0,
                left: 20,
                display: 'flex',
                justifyContent: 'center',
                top: 60,
              }}
            >
              <svg
                width='195'
                height='57'
                viewBox='0 0 195 57'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M7.14062 50.0703C7.14062 49.8359 7.10417 49.6276 7.03125 49.4453C6.96354 49.263 6.84115 49.0964 6.66406 48.9453C6.48698 48.7943 6.23698 48.6484 5.91406 48.5078C5.59635 48.362 5.1901 48.2135 4.69531 48.0625C4.15365 47.8958 3.65365 47.7109 3.19531 47.5078C2.74219 47.2995 2.34635 47.0599 2.00781 46.7891C1.66927 46.513 1.40625 46.1979 1.21875 45.8438C1.03125 45.4844 0.9375 45.0703 0.9375 44.6016C0.9375 44.138 1.03385 43.7161 1.22656 43.3359C1.42448 42.9557 1.70312 42.6276 2.0625 42.3516C2.42708 42.0703 2.85677 41.8542 3.35156 41.7031C3.84635 41.5469 4.39323 41.4688 4.99219 41.4688C5.83594 41.4688 6.5625 41.625 7.17188 41.9375C7.78646 42.25 8.25781 42.6693 8.58594 43.1953C8.91927 43.7214 9.08594 44.3021 9.08594 44.9375H7.14062C7.14062 44.5625 7.0599 44.2318 6.89844 43.9453C6.74219 43.6536 6.5026 43.4245 6.17969 43.2578C5.86198 43.0911 5.45833 43.0078 4.96875 43.0078C4.50521 43.0078 4.11979 43.0781 3.8125 43.2188C3.50521 43.3594 3.27604 43.5495 3.125 43.7891C2.97396 44.0286 2.89844 44.2995 2.89844 44.6016C2.89844 44.8151 2.94792 45.0104 3.04688 45.1875C3.14583 45.3594 3.29688 45.5208 3.5 45.6719C3.70312 45.8177 3.95833 45.9557 4.26562 46.0859C4.57292 46.2161 4.9349 46.3411 5.35156 46.4609C5.98177 46.6484 6.53125 46.8568 7 47.0859C7.46875 47.3099 7.85938 47.5651 8.17188 47.8516C8.48438 48.138 8.71875 48.4635 8.875 48.8281C9.03125 49.1875 9.10938 49.5964 9.10938 50.0547C9.10938 50.5339 9.01302 50.9661 8.82031 51.3516C8.6276 51.7318 8.35156 52.0573 7.99219 52.3281C7.63802 52.5938 7.21094 52.7995 6.71094 52.9453C6.21615 53.0859 5.66406 53.1562 5.05469 53.1562C4.50781 53.1562 3.96875 53.0833 3.4375 52.9375C2.91146 52.7917 2.43229 52.5703 2 52.2734C1.56771 51.9714 1.22396 51.5964 0.96875 51.1484C0.713542 50.6953 0.585938 50.1667 0.585938 49.5625H2.54688C2.54688 49.9323 2.60938 50.2474 2.73438 50.5078C2.86458 50.7682 3.04427 50.9818 3.27344 51.1484C3.5026 51.3099 3.76823 51.4297 4.07031 51.5078C4.3776 51.5859 4.70573 51.625 5.05469 51.625C5.51302 51.625 5.89583 51.5599 6.20312 51.4297C6.51562 51.2995 6.75 51.1172 6.90625 50.8828C7.0625 50.6484 7.14062 50.3776 7.14062 50.0703ZM12.9531 51.125L14.9062 44.5469H16.1094L15.7812 46.5156L13.8125 53H12.7344L12.9531 51.125ZM11.8047 44.5469L13.3281 51.1562L13.4531 53H12.25L9.96094 44.5469H11.8047ZM17.9375 51.0781L19.4141 44.5469H21.25L18.9688 53H17.7656L17.9375 51.0781ZM16.3125 44.5469L18.2422 51.0469L18.4844 53H17.4062L15.4141 46.5078L15.0859 44.5469H16.3125ZM24.5469 44.5469V53H22.6562V44.5469H24.5469ZM22.5312 42.3281C22.5312 42.0417 22.625 41.8047 22.8125 41.6172C23.0052 41.4245 23.2708 41.3281 23.6094 41.3281C23.9427 41.3281 24.2057 41.4245 24.3984 41.6172C24.5911 41.8047 24.6875 42.0417 24.6875 42.3281C24.6875 42.6094 24.5911 42.8438 24.3984 43.0312C24.2057 43.2188 23.9427 43.3125 23.6094 43.3125C23.2708 43.3125 23.0052 43.2188 22.8125 43.0312C22.625 42.8438 22.5312 42.6094 22.5312 42.3281ZM30.4844 44.5469V45.9219H25.7188V44.5469H30.4844ZM27.0938 42.4766H28.9766V50.6641C28.9766 50.9245 29.013 51.125 29.0859 51.2656C29.1641 51.401 29.2708 51.4922 29.4062 51.5391C29.5417 51.5859 29.7005 51.6094 29.8828 51.6094C30.013 51.6094 30.138 51.6016 30.2578 51.5859C30.3776 51.5703 30.474 51.5547 30.5469 51.5391L30.5547 52.9766C30.3984 53.0234 30.2161 53.0651 30.0078 53.1016C29.8047 53.138 29.5703 53.1562 29.3047 53.1562C28.8724 53.1562 28.4896 53.0807 28.1562 52.9297C27.8229 52.7734 27.5625 52.5208 27.375 52.1719C27.1875 51.8229 27.0938 51.3594 27.0938 50.7812V42.4766ZM35.3906 51.6562C35.6979 51.6562 35.974 51.5964 36.2188 51.4766C36.4688 51.3516 36.6693 51.1797 36.8203 50.9609C36.9766 50.7422 37.0625 50.4896 37.0781 50.2031H38.8516C38.8411 50.75 38.6797 51.2474 38.3672 51.6953C38.0547 52.1432 37.6406 52.5 37.125 52.7656C36.6094 53.026 36.0391 53.1562 35.4141 53.1562C34.7682 53.1562 34.2057 53.0469 33.7266 52.8281C33.2474 52.6042 32.849 52.2969 32.5312 51.9062C32.2135 51.5156 31.974 51.0651 31.8125 50.5547C31.6562 50.0443 31.5781 49.4974 31.5781 48.9141V48.6406C31.5781 48.0573 31.6562 47.5104 31.8125 47C31.974 46.4844 32.2135 46.0312 32.5312 45.6406C32.849 45.25 33.2474 44.9453 33.7266 44.7266C34.2057 44.5026 34.7656 44.3906 35.4062 44.3906C36.0833 44.3906 36.6771 44.526 37.1875 44.7969C37.6979 45.0625 38.099 45.4349 38.3906 45.9141C38.6875 46.388 38.8411 46.9401 38.8516 47.5703H37.0781C37.0625 47.2578 36.9844 46.9766 36.8438 46.7266C36.7083 46.4714 36.5156 46.2682 36.2656 46.1172C36.0208 45.9661 35.7266 45.8906 35.3828 45.8906C35.0026 45.8906 34.6875 45.9688 34.4375 46.125C34.1875 46.276 33.9922 46.4844 33.8516 46.75C33.7109 47.0104 33.6094 47.3047 33.5469 47.6328C33.4896 47.9557 33.4609 48.2917 33.4609 48.6406V48.9141C33.4609 49.263 33.4896 49.6016 33.5469 49.9297C33.6042 50.2578 33.7031 50.5521 33.8438 50.8125C33.9896 51.0677 34.1875 51.2734 34.4375 51.4297C34.6875 51.5807 35.0052 51.6562 35.3906 51.6562ZM42.1562 41V53H40.2812V41H42.1562ZM41.8281 48.4609L41.2188 48.4531C41.224 47.8698 41.3047 47.3307 41.4609 46.8359C41.6224 46.3411 41.8464 45.9115 42.1328 45.5469C42.4245 45.1771 42.7734 44.8932 43.1797 44.6953C43.5859 44.4922 44.0365 44.3906 44.5312 44.3906C44.9479 44.3906 45.3229 44.4479 45.6562 44.5625C45.9948 44.6771 46.2865 44.862 46.5312 45.1172C46.776 45.3672 46.9609 45.6953 47.0859 46.1016C47.2161 46.5026 47.2812 46.9922 47.2812 47.5703V53H45.3906V47.5547C45.3906 47.1484 45.3307 46.8255 45.2109 46.5859C45.0964 46.3464 44.9271 46.1745 44.7031 46.0703C44.4792 45.9609 44.2057 45.9062 43.8828 45.9062C43.5443 45.9062 43.2448 45.974 42.9844 46.1094C42.7292 46.2448 42.5156 46.4297 42.3438 46.6641C42.1719 46.8984 42.0417 47.1693 41.9531 47.4766C41.8698 47.7839 41.8281 48.112 41.8281 48.4609ZM57.0469 44.5469V45.9219H52.2812V44.5469H57.0469ZM53.6562 42.4766H55.5391V50.6641C55.5391 50.9245 55.5755 51.125 55.6484 51.2656C55.7266 51.401 55.8333 51.4922 55.9688 51.5391C56.1042 51.5859 56.263 51.6094 56.4453 51.6094C56.5755 51.6094 56.7005 51.6016 56.8203 51.5859C56.9401 51.5703 57.0365 51.5547 57.1094 51.5391L57.1172 52.9766C56.9609 53.0234 56.7786 53.0651 56.5703 53.1016C56.3672 53.138 56.1328 53.1562 55.8672 53.1562C55.4349 53.1562 55.0521 53.0807 54.7188 52.9297C54.3854 52.7734 54.125 52.5208 53.9375 52.1719C53.75 51.8229 53.6562 51.3594 53.6562 50.7812V42.4766ZM57.9531 48.8672V48.6875C57.9531 48.0781 58.0417 47.513 58.2188 46.9922C58.3958 46.4661 58.651 46.0104 58.9844 45.625C59.3229 45.2344 59.7344 44.9323 60.2188 44.7188C60.7083 44.5 61.2604 44.3906 61.875 44.3906C62.4948 44.3906 63.0469 44.5 63.5312 44.7188C64.0208 44.9323 64.4349 45.2344 64.7734 45.625C65.112 46.0104 65.3698 46.4661 65.5469 46.9922C65.724 47.513 65.8125 48.0781 65.8125 48.6875V48.8672C65.8125 49.4766 65.724 50.0417 65.5469 50.5625C65.3698 51.0833 65.112 51.5391 64.7734 51.9297C64.4349 52.3151 64.0234 52.6172 63.5391 52.8359C63.0547 53.0495 62.5052 53.1562 61.8906 53.1562C61.2708 53.1562 60.7161 53.0495 60.2266 52.8359C59.7422 52.6172 59.3307 52.3151 58.9922 51.9297C58.6536 51.5391 58.3958 51.0833 58.2188 50.5625C58.0417 50.0417 57.9531 49.4766 57.9531 48.8672ZM59.8359 48.6875V48.8672C59.8359 49.2474 59.875 49.6068 59.9531 49.9453C60.0312 50.2839 60.1536 50.5807 60.3203 50.8359C60.487 51.0911 60.7005 51.2917 60.9609 51.4375C61.2214 51.5833 61.5312 51.6562 61.8906 51.6562C62.2396 51.6562 62.5417 51.5833 62.7969 51.4375C63.0573 51.2917 63.2708 51.0911 63.4375 50.8359C63.6042 50.5807 63.7266 50.2839 63.8047 49.9453C63.888 49.6068 63.9297 49.2474 63.9297 48.8672V48.6875C63.9297 48.3125 63.888 47.9583 63.8047 47.625C63.7266 47.2865 63.6016 46.987 63.4297 46.7266C63.263 46.4661 63.0495 46.263 62.7891 46.1172C62.5339 45.9661 62.2292 45.8906 61.875 45.8906C61.5208 45.8906 61.2135 45.9661 60.9531 46.1172C60.6979 46.263 60.487 46.4661 60.3203 46.7266C60.1536 46.987 60.0312 47.2865 59.9531 47.625C59.875 47.9583 59.8359 48.3125 59.8359 48.6875ZM73.3906 41V53H71.5V41H73.3906ZM77.4688 44.5469V53H75.5781V44.5469H77.4688ZM75.4531 42.3281C75.4531 42.0417 75.5469 41.8047 75.7344 41.6172C75.9271 41.4245 76.1927 41.3281 76.5312 41.3281C76.8646 41.3281 77.1276 41.4245 77.3203 41.6172C77.513 41.8047 77.6094 42.0417 77.6094 42.3281C77.6094 42.6094 77.513 42.8438 77.3203 43.0312C77.1276 43.2188 76.8646 43.3125 76.5312 43.3125C76.1927 43.3125 75.9271 43.2188 75.7344 43.0312C75.5469 42.8438 75.4531 42.6094 75.4531 42.3281ZM84.2734 50.7109C84.2734 50.5234 84.2266 50.3542 84.1328 50.2031C84.0391 50.0469 83.8594 49.9062 83.5938 49.7812C83.3333 49.6562 82.9479 49.5417 82.4375 49.4375C81.9896 49.3385 81.5781 49.2214 81.2031 49.0859C80.8333 48.9453 80.5156 48.776 80.25 48.5781C79.9844 48.3802 79.7786 48.1458 79.6328 47.875C79.487 47.6042 79.4141 47.2917 79.4141 46.9375C79.4141 46.5938 79.4896 46.2682 79.6406 45.9609C79.7917 45.6536 80.0078 45.3828 80.2891 45.1484C80.5703 44.9141 80.9115 44.7292 81.3125 44.5938C81.7188 44.4583 82.1719 44.3906 82.6719 44.3906C83.3802 44.3906 83.987 44.5104 84.4922 44.75C85.0026 44.9844 85.3932 45.3047 85.6641 45.7109C85.9349 46.112 86.0703 46.5651 86.0703 47.0703H84.1875C84.1875 46.8464 84.1302 46.638 84.0156 46.4453C83.9062 46.2474 83.7396 46.0885 83.5156 45.9688C83.2917 45.8438 83.0104 45.7812 82.6719 45.7812C82.349 45.7812 82.0807 45.8333 81.8672 45.9375C81.6589 46.0365 81.5026 46.1667 81.3984 46.3281C81.2995 46.4896 81.25 46.6667 81.25 46.8594C81.25 47 81.276 47.1276 81.3281 47.2422C81.3854 47.3516 81.4792 47.4531 81.6094 47.5469C81.7396 47.6354 81.9167 47.7188 82.1406 47.7969C82.3698 47.875 82.6562 47.9505 83 48.0234C83.6458 48.1589 84.2005 48.3333 84.6641 48.5469C85.1328 48.7552 85.4922 49.026 85.7422 49.3594C85.9922 49.6875 86.1172 50.1042 86.1172 50.6094C86.1172 50.9844 86.0365 51.3281 85.875 51.6406C85.7188 51.9479 85.4896 52.2161 85.1875 52.4453C84.8854 52.6693 84.5234 52.8438 84.1016 52.9688C83.6849 53.0938 83.2161 53.1562 82.6953 53.1562C81.9297 53.1562 81.2812 53.0208 80.75 52.75C80.2188 52.474 79.8151 52.1224 79.5391 51.6953C79.2682 51.263 79.1328 50.8151 79.1328 50.3516H80.9531C80.974 50.7005 81.0703 50.9792 81.2422 51.1875C81.4193 51.3906 81.638 51.5391 81.8984 51.6328C82.1641 51.7214 82.4375 51.7656 82.7188 51.7656C83.0573 51.7656 83.3411 51.7214 83.5703 51.6328C83.7995 51.5391 83.974 51.4141 84.0938 51.2578C84.2135 51.0964 84.2734 50.9141 84.2734 50.7109ZM91.6406 44.5469V45.9219H86.875V44.5469H91.6406ZM88.25 42.4766H90.1328V50.6641C90.1328 50.9245 90.1693 51.125 90.2422 51.2656C90.3203 51.401 90.4271 51.4922 90.5625 51.5391C90.6979 51.5859 90.8568 51.6094 91.0391 51.6094C91.1693 51.6094 91.2943 51.6016 91.4141 51.5859C91.5339 51.5703 91.6302 51.5547 91.7031 51.5391L91.7109 52.9766C91.5547 53.0234 91.3724 53.0651 91.1641 53.1016C90.9609 53.138 90.7266 53.1562 90.4609 53.1562C90.0286 53.1562 89.6458 53.0807 89.3125 52.9297C88.9792 52.7734 88.7188 52.5208 88.5312 52.1719C88.3438 51.8229 88.25 51.3594 88.25 50.7812V42.4766ZM101.844 51.3047V47.2734C101.844 46.9714 101.789 46.7109 101.68 46.4922C101.57 46.2734 101.404 46.1042 101.18 45.9844C100.961 45.8646 100.685 45.8047 100.352 45.8047C100.044 45.8047 99.7786 45.8568 99.5547 45.9609C99.3307 46.0651 99.1562 46.2057 99.0312 46.3828C98.9062 46.5599 98.8438 46.7604 98.8438 46.9844H96.9688C96.9688 46.651 97.0495 46.3281 97.2109 46.0156C97.3724 45.7031 97.6068 45.4245 97.9141 45.1797C98.2214 44.9349 98.5885 44.7422 99.0156 44.6016C99.4427 44.4609 99.9219 44.3906 100.453 44.3906C101.089 44.3906 101.651 44.4974 102.141 44.7109C102.635 44.9245 103.023 45.2474 103.305 45.6797C103.591 46.1068 103.734 46.6432 103.734 47.2891V51.0469C103.734 51.4323 103.76 51.7786 103.812 52.0859C103.87 52.388 103.951 52.651 104.055 52.875V53H102.125C102.036 52.7969 101.966 52.5391 101.914 52.2266C101.867 51.9089 101.844 51.6016 101.844 51.3047ZM102.117 47.8594L102.133 49.0234H100.781C100.432 49.0234 100.125 49.0573 99.8594 49.125C99.5938 49.1875 99.3724 49.2812 99.1953 49.4062C99.0182 49.5312 98.8854 49.6823 98.7969 49.8594C98.7083 50.0365 98.6641 50.237 98.6641 50.4609C98.6641 50.6849 98.7161 50.8906 98.8203 51.0781C98.9245 51.2604 99.0755 51.4036 99.2734 51.5078C99.4766 51.612 99.7214 51.6641 100.008 51.6641C100.393 51.6641 100.729 51.5859 101.016 51.4297C101.307 51.2682 101.536 51.0729 101.703 50.8438C101.87 50.6094 101.958 50.388 101.969 50.1797L102.578 51.0156C102.516 51.2292 102.409 51.4583 102.258 51.7031C102.107 51.9479 101.909 52.1823 101.664 52.4062C101.424 52.625 101.135 52.8047 100.797 52.9453C100.464 53.0859 100.078 53.1562 99.6406 53.1562C99.0885 53.1562 98.5964 53.0469 98.1641 52.8281C97.7318 52.6042 97.3932 52.3047 97.1484 51.9297C96.9036 51.5495 96.7812 51.1198 96.7812 50.6406C96.7812 50.1927 96.8646 49.7969 97.0312 49.4531C97.2031 49.1042 97.4531 48.8125 97.7812 48.5781C98.1146 48.3438 98.5208 48.1667 99 48.0469C99.4792 47.9219 100.026 47.8594 100.641 47.8594H102.117ZM107.57 46.3516V53H105.688V44.5469H107.461L107.57 46.3516ZM107.234 48.4609L106.625 48.4531C106.63 47.8542 106.714 47.3047 106.875 46.8047C107.042 46.3047 107.271 45.875 107.562 45.5156C107.859 45.1562 108.214 44.8802 108.625 44.6875C109.036 44.4896 109.495 44.3906 110 44.3906C110.406 44.3906 110.773 44.4479 111.102 44.5625C111.435 44.6719 111.719 44.8516 111.953 45.1016C112.193 45.3516 112.375 45.6771 112.5 46.0781C112.625 46.474 112.688 46.9609 112.688 47.5391V53H110.797V47.5312C110.797 47.125 110.737 46.8047 110.617 46.5703C110.503 46.3307 110.333 46.1615 110.109 46.0625C109.891 45.9583 109.617 45.9062 109.289 45.9062C108.966 45.9062 108.677 45.974 108.422 46.1094C108.167 46.2448 107.951 46.4297 107.773 46.6641C107.602 46.8984 107.469 47.1693 107.375 47.4766C107.281 47.7839 107.234 48.112 107.234 48.4609ZM119.766 51.25V41H121.656V53H119.945L119.766 51.25ZM114.266 48.8672V48.7031C114.266 48.0625 114.341 47.4792 114.492 46.9531C114.643 46.4219 114.862 45.9661 115.148 45.5859C115.435 45.2005 115.784 44.9062 116.195 44.7031C116.607 44.4948 117.07 44.3906 117.586 44.3906C118.096 44.3906 118.544 44.4896 118.93 44.6875C119.315 44.8854 119.643 45.1693 119.914 45.5391C120.185 45.9036 120.401 46.3411 120.562 46.8516C120.724 47.3568 120.839 47.9193 120.906 48.5391V49.0625C120.839 49.6667 120.724 50.2188 120.562 50.7188C120.401 51.2188 120.185 51.651 119.914 52.0156C119.643 52.3802 119.312 52.6615 118.922 52.8594C118.536 53.0573 118.086 53.1562 117.57 53.1562C117.06 53.1562 116.599 53.0495 116.188 52.8359C115.781 52.6224 115.435 52.3229 115.148 51.9375C114.862 51.5521 114.643 51.099 114.492 50.5781C114.341 50.0521 114.266 49.4818 114.266 48.8672ZM116.148 48.7031V48.8672C116.148 49.2526 116.182 49.612 116.25 49.9453C116.323 50.2786 116.435 50.5729 116.586 50.8281C116.737 51.0781 116.932 51.276 117.172 51.4219C117.417 51.5625 117.708 51.6328 118.047 51.6328C118.474 51.6328 118.826 51.5391 119.102 51.3516C119.378 51.1641 119.594 50.9115 119.75 50.5938C119.911 50.2708 120.021 49.9115 120.078 49.5156V48.1016C120.047 47.7943 119.982 47.5078 119.883 47.2422C119.789 46.9766 119.661 46.7448 119.5 46.5469C119.339 46.3438 119.138 46.1875 118.898 46.0781C118.664 45.9635 118.385 45.9062 118.062 45.9062C117.719 45.9062 117.427 45.9792 117.188 46.125C116.948 46.2708 116.75 46.4714 116.594 46.7266C116.443 46.9818 116.331 47.2786 116.258 47.6172C116.185 47.9557 116.148 48.3177 116.148 48.7031ZM129.492 46.2656V53H127.609V44.5469H129.383L129.492 46.2656ZM129.188 48.4609L128.547 48.4531C128.547 47.8698 128.62 47.3307 128.766 46.8359C128.911 46.3411 129.125 45.9115 129.406 45.5469C129.688 45.1771 130.036 44.8932 130.453 44.6953C130.875 44.4922 131.362 44.3906 131.914 44.3906C132.299 44.3906 132.651 44.4479 132.969 44.5625C133.292 44.6719 133.57 44.8464 133.805 45.0859C134.044 45.3255 134.227 45.6328 134.352 46.0078C134.482 46.3828 134.547 46.8359 134.547 47.3672V53H132.664V47.5312C132.664 47.1198 132.602 46.7969 132.477 46.5625C132.357 46.3281 132.182 46.1615 131.953 46.0625C131.729 45.9583 131.461 45.9062 131.148 45.9062C130.794 45.9062 130.492 45.974 130.242 46.1094C129.997 46.2448 129.797 46.4297 129.641 46.6641C129.484 46.8984 129.37 47.1693 129.297 47.4766C129.224 47.7839 129.188 48.112 129.188 48.4609ZM134.43 47.9609L133.547 48.1562C133.547 47.6458 133.617 47.1641 133.758 46.7109C133.904 46.2526 134.115 45.8516 134.391 45.5078C134.672 45.1589 135.018 44.8854 135.43 44.6875C135.841 44.4896 136.312 44.3906 136.844 44.3906C137.276 44.3906 137.661 44.4505 138 44.5703C138.344 44.6849 138.635 44.8672 138.875 45.1172C139.115 45.3672 139.297 45.6927 139.422 46.0938C139.547 46.4896 139.609 46.9688 139.609 47.5312V53H137.719V47.5234C137.719 47.0964 137.656 46.7656 137.531 46.5312C137.411 46.2969 137.24 46.1354 137.016 46.0469C136.792 45.9531 136.523 45.9062 136.211 45.9062C135.919 45.9062 135.661 45.9609 135.438 46.0703C135.219 46.1745 135.034 46.3229 134.883 46.5156C134.732 46.7031 134.617 46.9193 134.539 47.1641C134.466 47.4089 134.43 47.6745 134.43 47.9609ZM146.312 51.3047V47.2734C146.312 46.9714 146.258 46.7109 146.148 46.4922C146.039 46.2734 145.872 46.1042 145.648 45.9844C145.43 45.8646 145.154 45.8047 144.82 45.8047C144.513 45.8047 144.247 45.8568 144.023 45.9609C143.799 46.0651 143.625 46.2057 143.5 46.3828C143.375 46.5599 143.312 46.7604 143.312 46.9844H141.438C141.438 46.651 141.518 46.3281 141.68 46.0156C141.841 45.7031 142.076 45.4245 142.383 45.1797C142.69 44.9349 143.057 44.7422 143.484 44.6016C143.911 44.4609 144.391 44.3906 144.922 44.3906C145.557 44.3906 146.12 44.4974 146.609 44.7109C147.104 44.9245 147.492 45.2474 147.773 45.6797C148.06 46.1068 148.203 46.6432 148.203 47.2891V51.0469C148.203 51.4323 148.229 51.7786 148.281 52.0859C148.339 52.388 148.419 52.651 148.523 52.875V53H146.594C146.505 52.7969 146.435 52.5391 146.383 52.2266C146.336 51.9089 146.312 51.6016 146.312 51.3047ZM146.586 47.8594L146.602 49.0234H145.25C144.901 49.0234 144.594 49.0573 144.328 49.125C144.062 49.1875 143.841 49.2812 143.664 49.4062C143.487 49.5312 143.354 49.6823 143.266 49.8594C143.177 50.0365 143.133 50.237 143.133 50.4609C143.133 50.6849 143.185 50.8906 143.289 51.0781C143.393 51.2604 143.544 51.4036 143.742 51.5078C143.945 51.612 144.19 51.6641 144.477 51.6641C144.862 51.6641 145.198 51.5859 145.484 51.4297C145.776 51.2682 146.005 51.0729 146.172 50.8438C146.339 50.6094 146.427 50.388 146.438 50.1797L147.047 51.0156C146.984 51.2292 146.878 51.4583 146.727 51.7031C146.576 51.9479 146.378 52.1823 146.133 52.4062C145.893 52.625 145.604 52.8047 145.266 52.9453C144.932 53.0859 144.547 53.1562 144.109 53.1562C143.557 53.1562 143.065 53.0469 142.633 52.8281C142.201 52.6042 141.862 52.3047 141.617 51.9297C141.372 51.5495 141.25 51.1198 141.25 50.6406C141.25 50.1927 141.333 49.7969 141.5 49.4531C141.672 49.1042 141.922 48.8125 142.25 48.5781C142.583 48.3438 142.99 48.1667 143.469 48.0469C143.948 47.9219 144.495 47.8594 145.109 47.8594H146.586ZM152.062 46.1719V56.25H150.18V44.5469H151.914L152.062 46.1719ZM157.57 48.6953V48.8594C157.57 49.474 157.497 50.0443 157.352 50.5703C157.211 51.0911 157 51.5469 156.719 51.9375C156.443 52.3229 156.102 52.6224 155.695 52.8359C155.289 53.0495 154.82 53.1562 154.289 53.1562C153.763 53.1562 153.302 53.0599 152.906 52.8672C152.516 52.6693 152.185 52.3906 151.914 52.0312C151.643 51.6719 151.424 51.25 151.258 50.7656C151.096 50.276 150.982 49.7396 150.914 49.1562V48.5234C150.982 47.9036 151.096 47.3411 151.258 46.8359C151.424 46.3307 151.643 45.8958 151.914 45.5312C152.185 45.1667 152.516 44.8854 152.906 44.6875C153.297 44.4896 153.753 44.3906 154.273 44.3906C154.805 44.3906 155.276 44.4948 155.688 44.7031C156.099 44.9062 156.445 45.1979 156.727 45.5781C157.008 45.9531 157.219 46.4062 157.359 46.9375C157.5 47.4635 157.57 48.0495 157.57 48.6953ZM155.688 48.8594V48.6953C155.688 48.3047 155.651 47.9427 155.578 47.6094C155.505 47.2708 155.391 46.974 155.234 46.7188C155.078 46.4635 154.878 46.2656 154.633 46.125C154.393 45.9792 154.104 45.9062 153.766 45.9062C153.432 45.9062 153.146 45.9635 152.906 46.0781C152.667 46.1875 152.466 46.3411 152.305 46.5391C152.143 46.737 152.018 46.9688 151.93 47.2344C151.841 47.4948 151.779 47.7786 151.742 48.0859V49.6016C151.805 49.9766 151.911 50.3203 152.062 50.6328C152.214 50.9453 152.427 51.1953 152.703 51.3828C152.984 51.5651 153.344 51.6562 153.781 51.6562C154.12 51.6562 154.409 51.5833 154.648 51.4375C154.888 51.2917 155.083 51.0911 155.234 50.8359C155.391 50.5755 155.505 50.276 155.578 49.9375C155.651 49.599 155.688 49.2396 155.688 48.8594ZM165.906 51.5078L167.977 44.5469H169.93L166.992 53H165.773L165.906 51.5078ZM164.32 44.5469L166.43 51.5391L166.531 53H165.312L162.359 44.5469H164.32ZM173.109 44.5469V53H171.219V44.5469H173.109ZM171.094 42.3281C171.094 42.0417 171.188 41.8047 171.375 41.6172C171.568 41.4245 171.833 41.3281 172.172 41.3281C172.505 41.3281 172.768 41.4245 172.961 41.6172C173.154 41.8047 173.25 42.0417 173.25 42.3281C173.25 42.6094 173.154 42.8438 172.961 43.0312C172.768 43.2188 172.505 43.3125 172.172 43.3125C171.833 43.3125 171.568 43.2188 171.375 43.0312C171.188 42.8438 171.094 42.6094 171.094 42.3281ZM178.898 53.1562C178.273 53.1562 177.708 53.0547 177.203 52.8516C176.703 52.6432 176.276 52.3542 175.922 51.9844C175.573 51.6146 175.305 51.1797 175.117 50.6797C174.93 50.1797 174.836 49.6406 174.836 49.0625V48.75C174.836 48.0885 174.932 47.4896 175.125 46.9531C175.318 46.4167 175.586 45.9583 175.93 45.5781C176.273 45.1927 176.68 44.8984 177.148 44.6953C177.617 44.4922 178.125 44.3906 178.672 44.3906C179.276 44.3906 179.805 44.4922 180.258 44.6953C180.711 44.8984 181.086 45.1849 181.383 45.5547C181.685 45.9193 181.909 46.3542 182.055 46.8594C182.206 47.3646 182.281 47.9219 182.281 48.5312V49.3359H175.75V47.9844H180.422V47.8359C180.411 47.4974 180.344 47.1797 180.219 46.8828C180.099 46.5859 179.914 46.3464 179.664 46.1641C179.414 45.9818 179.081 45.8906 178.664 45.8906C178.352 45.8906 178.073 45.9583 177.828 46.0938C177.589 46.224 177.388 46.4141 177.227 46.6641C177.065 46.9141 176.94 47.2161 176.852 47.5703C176.768 47.9193 176.727 48.3125 176.727 48.75V49.0625C176.727 49.4323 176.776 49.776 176.875 50.0938C176.979 50.4062 177.13 50.6797 177.328 50.9141C177.526 51.1484 177.766 51.3333 178.047 51.4688C178.328 51.599 178.648 51.6641 179.008 51.6641C179.461 51.6641 179.865 51.5729 180.219 51.3906C180.573 51.2083 180.88 50.9505 181.141 50.6172L182.133 51.5781C181.951 51.8438 181.714 52.099 181.422 52.3438C181.13 52.5833 180.773 52.7786 180.352 52.9297C179.935 53.0807 179.451 53.1562 178.898 53.1562ZM186.047 51.125L188 44.5469H189.203L188.875 46.5156L186.906 53H185.828L186.047 51.125ZM184.898 44.5469L186.422 51.1562L186.547 53H185.344L183.055 44.5469H184.898ZM191.031 51.0781L192.508 44.5469H194.344L192.062 53H190.859L191.031 51.0781ZM189.406 44.5469L191.336 51.0469L191.578 53H190.5L188.508 46.5078L188.18 44.5469H189.406Z'
                  fill='white'
                />
                <path
                  d='M90.2043 0.792744C89.8137 0.402302 89.1805 0.402436 88.7901 0.793043L82.4275 7.15835C82.037 7.54896 82.0372 8.18212 82.4278 8.57256C82.8184 8.963 83.4516 8.96287 83.842 8.57226L89.4977 2.91421L95.1557 8.56987C95.5463 8.96031 96.1795 8.96018 96.5699 8.56957C96.9604 8.17897 96.9602 7.5458 96.5696 7.15536L90.2043 0.792744ZM88.5 28C88.5 28.5523 88.9477 29 89.5 29C90.0523 29 90.5 28.5523 90.5 28L88.5 28ZM88.4974 1.50021C88.4988 8.25014 88.4994 14.8751 88.4997 19.8126C88.4999 22.2813 88.5 24.3282 88.5 25.7578C88.5 26.4727 88.5 27.0332 88.5 27.415C88.5 27.606 88.5 27.7522 88.5 27.8507C88.5 27.9 88.5 27.9373 88.5 27.9623C88.5 27.9748 88.5 27.9842 88.5 27.9905C88.5 27.9937 88.5 27.996 88.5 27.9976C88.5 27.9984 88.5 27.999 88.5 27.9994C88.5 27.9996 88.5 27.9997 88.5 27.9998C88.5 27.9999 88.5 28 89.5 28C90.5 28 90.5 28 90.5 27.9999C90.5 27.9998 90.5 27.9996 90.5 27.9994C90.5 27.999 90.5 27.9984 90.5 27.9976C90.5 27.9961 90.5 27.9937 90.5 27.9905C90.5 27.9842 90.5 27.9748 90.5 27.9623C90.5 27.9373 90.5 27.9 90.5 27.8507C90.5 27.7522 90.5 27.606 90.5 27.415C90.5 27.0332 90.5 26.4726 90.5 25.7578C90.5 24.3281 90.4999 22.2812 90.4997 19.8124C90.4994 14.8749 90.4988 8.24986 90.4974 1.49979L88.4974 1.50021Z'
                  fill='white'
                />
              </svg>
            </div>

            <div
              style={{
                position: 'fixed',
                display: 'flex',
                flexDirection: 'column',
                bottom: withCloudCameras ? 140 : 95,
                right: 16,
                gap: 8,
              }}
            >
              <ZoomPanel
                colors={colors}
                renewal
                onMyLocation={() => {}}
                onZoomIn={() => {}}
                onZoomOut={() => {}}
                t={t}
                onLoading={() => {}}
                loading={false}
                noabs
                locPerm={locPerm}
                onFailedLocation={handleFailedLocation}
              />
              <TopRightControl
                round
                app
                t={t}
                themeState={themeState}
                activeAppFilter
                onDashcamPublic={() => {}}
              />
            </div>

            <div
              style={{
                position: 'fixed',
                right: 60,
                bottom: withCloudCameras ? 175 : 140,
              }}
            >
              <svg
                width='165'
                height='99'
                viewBox='0 0 165 99'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M11.5391 9.625H13.4922V17.2266C13.4922 18.0911 13.3047 18.8151 12.9297 19.3984C12.5547 19.9818 12.0443 20.4219 11.3984 20.7188C10.7578 21.0104 10.0417 21.1562 9.25 21.1562C8.43229 21.1562 7.70312 21.0104 7.0625 20.7188C6.42188 20.4219 5.91667 19.9818 5.54688 19.3984C5.18229 18.8151 5 18.0911 5 17.2266V9.625H6.95312V17.2266C6.95312 17.7734 7.04688 18.224 7.23438 18.5781C7.42188 18.9271 7.6875 19.1849 8.03125 19.3516C8.375 19.5182 8.78125 19.6016 9.25 19.6016C9.71875 19.6016 10.1224 19.5182 10.4609 19.3516C10.8047 19.1849 11.0703 18.9271 11.2578 18.5781C11.4453 18.224 11.5391 17.7734 11.5391 17.2266V9.625ZM20.1797 18.7109C20.1797 18.5234 20.1328 18.3542 20.0391 18.2031C19.9453 18.0469 19.7656 17.9062 19.5 17.7812C19.2396 17.6562 18.8542 17.5417 18.3438 17.4375C17.8958 17.3385 17.4844 17.2214 17.1094 17.0859C16.7396 16.9453 16.4219 16.776 16.1562 16.5781C15.8906 16.3802 15.6849 16.1458 15.5391 15.875C15.3932 15.6042 15.3203 15.2917 15.3203 14.9375C15.3203 14.5938 15.3958 14.2682 15.5469 13.9609C15.6979 13.6536 15.9141 13.3828 16.1953 13.1484C16.4766 12.9141 16.8177 12.7292 17.2188 12.5938C17.625 12.4583 18.0781 12.3906 18.5781 12.3906C19.2865 12.3906 19.8932 12.5104 20.3984 12.75C20.9089 12.9844 21.2995 13.3047 21.5703 13.7109C21.8411 14.112 21.9766 14.5651 21.9766 15.0703H20.0938C20.0938 14.8464 20.0365 14.638 19.9219 14.4453C19.8125 14.2474 19.6458 14.0885 19.4219 13.9688C19.1979 13.8438 18.9167 13.7812 18.5781 13.7812C18.2552 13.7812 17.987 13.8333 17.7734 13.9375C17.5651 14.0365 17.4089 14.1667 17.3047 14.3281C17.2057 14.4896 17.1562 14.6667 17.1562 14.8594C17.1562 15 17.1823 15.1276 17.2344 15.2422C17.2917 15.3516 17.3854 15.4531 17.5156 15.5469C17.6458 15.6354 17.8229 15.7188 18.0469 15.7969C18.276 15.875 18.5625 15.9505 18.9062 16.0234C19.5521 16.1589 20.1068 16.3333 20.5703 16.5469C21.0391 16.7552 21.3984 17.026 21.6484 17.3594C21.8984 17.6875 22.0234 18.1042 22.0234 18.6094C22.0234 18.9844 21.9427 19.3281 21.7812 19.6406C21.625 19.9479 21.3958 20.2161 21.0938 20.4453C20.7917 20.6693 20.4297 20.8438 20.0078 20.9688C19.5911 21.0938 19.1224 21.1562 18.6016 21.1562C17.8359 21.1562 17.1875 21.0208 16.6562 20.75C16.125 20.474 15.7214 20.1224 15.4453 19.6953C15.1745 19.263 15.0391 18.8151 15.0391 18.3516H16.8594C16.8802 18.7005 16.9766 18.9792 17.1484 19.1875C17.3255 19.3906 17.5443 19.5391 17.8047 19.6328C18.0703 19.7214 18.3438 19.7656 18.625 19.7656C18.9635 19.7656 19.2474 19.7214 19.4766 19.6328C19.7057 19.5391 19.8802 19.4141 20 19.2578C20.1198 19.0964 20.1797 18.9141 20.1797 18.7109ZM27.3984 21.1562C26.7734 21.1562 26.2083 21.0547 25.7031 20.8516C25.2031 20.6432 24.776 20.3542 24.4219 19.9844C24.0729 19.6146 23.8047 19.1797 23.6172 18.6797C23.4297 18.1797 23.3359 17.6406 23.3359 17.0625V16.75C23.3359 16.0885 23.4323 15.4896 23.625 14.9531C23.8177 14.4167 24.0859 13.9583 24.4297 13.5781C24.7734 13.1927 25.1797 12.8984 25.6484 12.6953C26.1172 12.4922 26.625 12.3906 27.1719 12.3906C27.776 12.3906 28.3047 12.4922 28.7578 12.6953C29.2109 12.8984 29.5859 13.1849 29.8828 13.5547C30.1849 13.9193 30.4089 14.3542 30.5547 14.8594C30.7057 15.3646 30.7812 15.9219 30.7812 16.5312V17.3359H24.25V15.9844H28.9219V15.8359C28.9115 15.4974 28.8438 15.1797 28.7188 14.8828C28.599 14.5859 28.4141 14.3464 28.1641 14.1641C27.9141 13.9818 27.5807 13.8906 27.1641 13.8906C26.8516 13.8906 26.5729 13.9583 26.3281 14.0938C26.0885 14.224 25.888 14.4141 25.7266 14.6641C25.5651 14.9141 25.4401 15.2161 25.3516 15.5703C25.2682 15.9193 25.2266 16.3125 25.2266 16.75V17.0625C25.2266 17.4323 25.276 17.776 25.375 18.0938C25.4792 18.4062 25.6302 18.6797 25.8281 18.9141C26.026 19.1484 26.2656 19.3333 26.5469 19.4688C26.8281 19.599 27.1484 19.6641 27.5078 19.6641C27.9609 19.6641 28.3646 19.5729 28.7188 19.3906C29.0729 19.2083 29.3802 18.9505 29.6406 18.6172L30.6328 19.5781C30.4505 19.8438 30.2135 20.099 29.9219 20.3438C29.6302 20.5833 29.2734 20.7786 28.8516 20.9297C28.4349 21.0807 27.9505 21.1562 27.3984 21.1562ZM34.1406 14.1562V21H32.2578V12.5469H34.0547L34.1406 14.1562ZM36.7266 12.4922L36.7109 14.2422C36.5964 14.2214 36.4714 14.2057 36.3359 14.1953C36.2057 14.1849 36.0755 14.1797 35.9453 14.1797C35.6224 14.1797 35.3385 14.2266 35.0938 14.3203C34.849 14.4089 34.6432 14.5391 34.4766 14.7109C34.3151 14.8776 34.1901 15.0807 34.1016 15.3203C34.013 15.5599 33.9609 15.8281 33.9453 16.125L33.5156 16.1562C33.5156 15.625 33.5677 15.1328 33.6719 14.6797C33.776 14.2266 33.9323 13.8281 34.1406 13.4844C34.3542 13.1406 34.6198 12.8724 34.9375 12.6797C35.2604 12.487 35.6328 12.3906 36.0547 12.3906C36.1693 12.3906 36.2917 12.401 36.4219 12.4219C36.5573 12.4427 36.6589 12.4661 36.7266 12.4922ZM49.2031 19.4453V21H43.4922V19.4453H49.2031ZM44.0391 9.625V21H42.0781V9.625H44.0391ZM50.1719 16.8672V16.6875C50.1719 16.0781 50.2604 15.513 50.4375 14.9922C50.6146 14.4661 50.8698 14.0104 51.2031 13.625C51.5417 13.2344 51.9531 12.9323 52.4375 12.7188C52.9271 12.5 53.4792 12.3906 54.0938 12.3906C54.7135 12.3906 55.2656 12.5 55.75 12.7188C56.2396 12.9323 56.6536 13.2344 56.9922 13.625C57.3307 14.0104 57.5885 14.4661 57.7656 14.9922C57.9427 15.513 58.0312 16.0781 58.0312 16.6875V16.8672C58.0312 17.4766 57.9427 18.0417 57.7656 18.5625C57.5885 19.0833 57.3307 19.5391 56.9922 19.9297C56.6536 20.3151 56.2422 20.6172 55.7578 20.8359C55.2734 21.0495 54.724 21.1562 54.1094 21.1562C53.4896 21.1562 52.9349 21.0495 52.4453 20.8359C51.9609 20.6172 51.5495 20.3151 51.2109 19.9297C50.8724 19.5391 50.6146 19.0833 50.4375 18.5625C50.2604 18.0417 50.1719 17.4766 50.1719 16.8672ZM52.0547 16.6875V16.8672C52.0547 17.2474 52.0938 17.6068 52.1719 17.9453C52.25 18.2839 52.3724 18.5807 52.5391 18.8359C52.7057 19.0911 52.9193 19.2917 53.1797 19.4375C53.4401 19.5833 53.75 19.6562 54.1094 19.6562C54.4583 19.6562 54.7604 19.5833 55.0156 19.4375C55.276 19.2917 55.4896 19.0911 55.6562 18.8359C55.8229 18.5807 55.9453 18.2839 56.0234 17.9453C56.1068 17.6068 56.1484 17.2474 56.1484 16.8672V16.6875C56.1484 16.3125 56.1068 15.9583 56.0234 15.625C55.9453 15.2865 55.8203 14.987 55.6484 14.7266C55.4818 14.4661 55.2682 14.263 55.0078 14.1172C54.7526 13.9661 54.4479 13.8906 54.0938 13.8906C53.7396 13.8906 53.4323 13.9661 53.1719 14.1172C52.9167 14.263 52.7057 14.4661 52.5391 14.7266C52.3724 14.987 52.25 15.2865 52.1719 15.625C52.0938 15.9583 52.0547 16.3125 52.0547 16.6875ZM63.0625 19.6562C63.3698 19.6562 63.6458 19.5964 63.8906 19.4766C64.1406 19.3516 64.3411 19.1797 64.4922 18.9609C64.6484 18.7422 64.7344 18.4896 64.75 18.2031H66.5234C66.513 18.75 66.3516 19.2474 66.0391 19.6953C65.7266 20.1432 65.3125 20.5 64.7969 20.7656C64.2812 21.026 63.7109 21.1562 63.0859 21.1562C62.4401 21.1562 61.8776 21.0469 61.3984 20.8281C60.9193 20.6042 60.5208 20.2969 60.2031 19.9062C59.8854 19.5156 59.6458 19.0651 59.4844 18.5547C59.3281 18.0443 59.25 17.4974 59.25 16.9141V16.6406C59.25 16.0573 59.3281 15.5104 59.4844 15C59.6458 14.4844 59.8854 14.0312 60.2031 13.6406C60.5208 13.25 60.9193 12.9453 61.3984 12.7266C61.8776 12.5026 62.4375 12.3906 63.0781 12.3906C63.7552 12.3906 64.349 12.526 64.8594 12.7969C65.3698 13.0625 65.7708 13.4349 66.0625 13.9141C66.3594 14.388 66.513 14.9401 66.5234 15.5703H64.75C64.7344 15.2578 64.6562 14.9766 64.5156 14.7266C64.3802 14.4714 64.1875 14.2682 63.9375 14.1172C63.6927 13.9661 63.3984 13.8906 63.0547 13.8906C62.6745 13.8906 62.3594 13.9688 62.1094 14.125C61.8594 14.276 61.6641 14.4844 61.5234 14.75C61.3828 15.0104 61.2812 15.3047 61.2188 15.6328C61.1615 15.9557 61.1328 16.2917 61.1328 16.6406V16.9141C61.1328 17.263 61.1615 17.6016 61.2188 17.9297C61.276 18.2578 61.375 18.5521 61.5156 18.8125C61.6615 19.0677 61.8594 19.2734 62.1094 19.4297C62.3594 19.5807 62.6771 19.6562 63.0625 19.6562ZM72.7344 19.3047V15.2734C72.7344 14.9714 72.6797 14.7109 72.5703 14.4922C72.4609 14.2734 72.2943 14.1042 72.0703 13.9844C71.8516 13.8646 71.5755 13.8047 71.2422 13.8047C70.9349 13.8047 70.6693 13.8568 70.4453 13.9609C70.2214 14.0651 70.0469 14.2057 69.9219 14.3828C69.7969 14.5599 69.7344 14.7604 69.7344 14.9844H67.8594C67.8594 14.651 67.9401 14.3281 68.1016 14.0156C68.263 13.7031 68.4974 13.4245 68.8047 13.1797C69.112 12.9349 69.4792 12.7422 69.9062 12.6016C70.3333 12.4609 70.8125 12.3906 71.3438 12.3906C71.9792 12.3906 72.5417 12.4974 73.0312 12.7109C73.526 12.9245 73.9141 13.2474 74.1953 13.6797C74.4818 14.1068 74.625 14.6432 74.625 15.2891V19.0469C74.625 19.4323 74.651 19.7786 74.7031 20.0859C74.7604 20.388 74.8411 20.651 74.9453 20.875V21H73.0156C72.9271 20.7969 72.8568 20.5391 72.8047 20.2266C72.7578 19.9089 72.7344 19.6016 72.7344 19.3047ZM73.0078 15.8594L73.0234 17.0234H71.6719C71.3229 17.0234 71.0156 17.0573 70.75 17.125C70.4844 17.1875 70.263 17.2812 70.0859 17.4062C69.9089 17.5312 69.776 17.6823 69.6875 17.8594C69.599 18.0365 69.5547 18.237 69.5547 18.4609C69.5547 18.6849 69.6068 18.8906 69.7109 19.0781C69.8151 19.2604 69.9661 19.4036 70.1641 19.5078C70.3672 19.612 70.612 19.6641 70.8984 19.6641C71.2839 19.6641 71.6198 19.5859 71.9062 19.4297C72.1979 19.2682 72.4271 19.0729 72.5938 18.8438C72.7604 18.6094 72.849 18.388 72.8594 18.1797L73.4688 19.0156C73.4062 19.2292 73.2995 19.4583 73.1484 19.7031C72.9974 19.9479 72.7995 20.1823 72.5547 20.4062C72.3151 20.625 72.026 20.8047 71.6875 20.9453C71.3542 21.0859 70.9688 21.1562 70.5312 21.1562C69.9792 21.1562 69.487 21.0469 69.0547 20.8281C68.6224 20.6042 68.2839 20.3047 68.0391 19.9297C67.7943 19.5495 67.6719 19.1198 67.6719 18.6406C67.6719 18.1927 67.7552 17.7969 67.9219 17.4531C68.0938 17.1042 68.3438 16.8125 68.6719 16.5781C69.0052 16.3438 69.4115 16.1667 69.8906 16.0469C70.3698 15.9219 70.9167 15.8594 71.5312 15.8594H73.0078ZM80.4688 12.5469V13.9219H75.7031V12.5469H80.4688ZM77.0781 10.4766H78.9609V18.6641C78.9609 18.9245 78.9974 19.125 79.0703 19.2656C79.1484 19.401 79.2552 19.4922 79.3906 19.5391C79.526 19.5859 79.6849 19.6094 79.8672 19.6094C79.9974 19.6094 80.1224 19.6016 80.2422 19.5859C80.362 19.5703 80.4583 19.5547 80.5312 19.5391L80.5391 20.9766C80.3828 21.0234 80.2005 21.0651 79.9922 21.1016C79.7891 21.138 79.5547 21.1562 79.2891 21.1562C78.8568 21.1562 78.474 21.0807 78.1406 20.9297C77.8073 20.7734 77.5469 20.5208 77.3594 20.1719C77.1719 19.8229 77.0781 19.3594 77.0781 18.7812V10.4766ZM83.9375 12.5469V21H82.0469V12.5469H83.9375ZM81.9219 10.3281C81.9219 10.0417 82.0156 9.80469 82.2031 9.61719C82.3958 9.42448 82.6615 9.32812 83 9.32812C83.3333 9.32812 83.5964 9.42448 83.7891 9.61719C83.9818 9.80469 84.0781 10.0417 84.0781 10.3281C84.0781 10.6094 83.9818 10.8438 83.7891 11.0312C83.5964 11.2188 83.3333 11.3125 83 11.3125C82.6615 11.3125 82.3958 11.2188 82.2031 11.0312C82.0156 10.8438 81.9219 10.6094 81.9219 10.3281ZM85.6406 16.8672V16.6875C85.6406 16.0781 85.7292 15.513 85.9062 14.9922C86.0833 14.4661 86.3385 14.0104 86.6719 13.625C87.0104 13.2344 87.4219 12.9323 87.9062 12.7188C88.3958 12.5 88.9479 12.3906 89.5625 12.3906C90.1823 12.3906 90.7344 12.5 91.2188 12.7188C91.7083 12.9323 92.1224 13.2344 92.4609 13.625C92.7995 14.0104 93.0573 14.4661 93.2344 14.9922C93.4115 15.513 93.5 16.0781 93.5 16.6875V16.8672C93.5 17.4766 93.4115 18.0417 93.2344 18.5625C93.0573 19.0833 92.7995 19.5391 92.4609 19.9297C92.1224 20.3151 91.7109 20.6172 91.2266 20.8359C90.7422 21.0495 90.1927 21.1562 89.5781 21.1562C88.9583 21.1562 88.4036 21.0495 87.9141 20.8359C87.4297 20.6172 87.0182 20.3151 86.6797 19.9297C86.3411 19.5391 86.0833 19.0833 85.9062 18.5625C85.7292 18.0417 85.6406 17.4766 85.6406 16.8672ZM87.5234 16.6875V16.8672C87.5234 17.2474 87.5625 17.6068 87.6406 17.9453C87.7188 18.2839 87.8411 18.5807 88.0078 18.8359C88.1745 19.0911 88.388 19.2917 88.6484 19.4375C88.9089 19.5833 89.2188 19.6562 89.5781 19.6562C89.9271 19.6562 90.2292 19.5833 90.4844 19.4375C90.7448 19.2917 90.9583 19.0911 91.125 18.8359C91.2917 18.5807 91.4141 18.2839 91.4922 17.9453C91.5755 17.6068 91.6172 17.2474 91.6172 16.8672V16.6875C91.6172 16.3125 91.5755 15.9583 91.4922 15.625C91.4141 15.2865 91.2891 14.987 91.1172 14.7266C90.9505 14.4661 90.737 14.263 90.4766 14.1172C90.2214 13.9661 89.9167 13.8906 89.5625 13.8906C89.2083 13.8906 88.901 13.9661 88.6406 14.1172C88.3854 14.263 88.1745 14.4661 88.0078 14.7266C87.8411 14.987 87.7188 15.2865 87.6406 15.625C87.5625 15.9583 87.5234 16.3125 87.5234 16.6875ZM96.9453 14.3516V21H95.0625V12.5469H96.8359L96.9453 14.3516ZM96.6094 16.4609L96 16.4531C96.0052 15.8542 96.0885 15.3047 96.25 14.8047C96.4167 14.3047 96.6458 13.875 96.9375 13.5156C97.2344 13.1562 97.5885 12.8802 98 12.6875C98.4115 12.4896 98.8698 12.3906 99.375 12.3906C99.7812 12.3906 100.148 12.4479 100.477 12.5625C100.81 12.6719 101.094 12.8516 101.328 13.1016C101.568 13.3516 101.75 13.6771 101.875 14.0781C102 14.474 102.062 14.9609 102.062 15.5391V21H100.172V15.5312C100.172 15.125 100.112 14.8047 99.9922 14.5703C99.8776 14.3307 99.7083 14.1615 99.4844 14.0625C99.2656 13.9583 98.9922 13.9062 98.6641 13.9062C98.3411 13.9062 98.0521 13.974 97.7969 14.1094C97.5417 14.2448 97.3255 14.4297 97.1484 14.6641C96.9766 14.8984 96.8438 15.1693 96.75 15.4766C96.6562 15.7839 96.6094 16.112 96.6094 16.4609Z'
                  fill='white'
                />
                <path
                  d='M162.975 44.3588C163.526 44.3984 164.005 43.9839 164.044 43.433L164.69 34.4562C164.729 33.9054 164.315 33.4267 163.764 33.3871C163.213 33.3475 162.735 33.7619 162.695 34.3128L162.121 42.2922L154.142 41.7184C153.591 41.6788 153.112 42.0933 153.073 42.6441C153.033 43.195 153.447 43.6737 153.998 43.7133L162.975 44.3588ZM114.477 18.0093C113.93 17.9361 113.426 18.3206 113.353 18.868C113.28 19.4154 113.665 19.9185 114.212 19.9916L114.477 18.0093ZM163.803 42.7068C154.902 32.427 142.544 26.2622 132.477 22.6684C127.434 20.8682 122.944 19.705 119.712 18.9913C118.095 18.6344 116.792 18.3897 115.891 18.2338C115.44 18.1558 115.089 18.1001 114.85 18.0636C114.73 18.0454 114.639 18.032 114.576 18.0231C114.545 18.0186 114.521 18.0152 114.504 18.013C114.496 18.0118 114.489 18.0109 114.485 18.0103C114.483 18.01 114.481 18.0098 114.479 18.0096C114.479 18.0095 114.478 18.0094 114.478 18.0094C114.477 18.0093 114.477 18.0093 114.344 19.0004C114.212 19.9916 114.212 19.9916 114.212 19.9916C114.212 19.9916 114.212 19.9916 114.212 19.9917C114.213 19.9918 114.214 19.9919 114.216 19.9921C114.219 19.9925 114.224 19.9932 114.23 19.9941C114.244 19.996 114.265 19.999 114.293 20.003C114.35 20.0111 114.435 20.0236 114.549 20.0408C114.775 20.0754 115.113 20.129 115.55 20.2045C116.424 20.3557 117.697 20.5946 119.281 20.9443C122.449 21.6439 126.857 22.7856 131.804 24.552C141.719 28.0915 153.712 34.1071 162.291 44.0159L163.803 42.7068Z'
                  fill='white'
                />
                <path
                  d='M70.1172 63.625V75H68.1562V63.625H70.1172ZM74.7578 68.6016V70.1562H69.6172V68.6016H74.7578ZM75.4062 63.625V65.1875H69.6172V63.625H75.4062ZM78.7969 66.5469V75H76.9062V66.5469H78.7969ZM76.7812 64.3281C76.7812 64.0417 76.875 63.8047 77.0625 63.6172C77.2552 63.4245 77.5208 63.3281 77.8594 63.3281C78.1927 63.3281 78.4557 63.4245 78.6484 63.6172C78.8411 63.8047 78.9375 64.0417 78.9375 64.3281C78.9375 64.6094 78.8411 64.8438 78.6484 65.0312C78.4557 65.2188 78.1927 65.3125 77.8594 65.3125C77.5208 65.3125 77.2552 65.2188 77.0625 65.0312C76.875 64.8438 76.7812 64.6094 76.7812 64.3281ZM82.875 63V75H80.9844V63H82.875ZM88.8125 66.5469V67.9219H84.0469V66.5469H88.8125ZM85.4219 64.4766H87.3047V72.6641C87.3047 72.9245 87.3411 73.125 87.4141 73.2656C87.4922 73.401 87.599 73.4922 87.7344 73.5391C87.8698 73.5859 88.0286 73.6094 88.2109 73.6094C88.3411 73.6094 88.4661 73.6016 88.5859 73.5859C88.7057 73.5703 88.8021 73.5547 88.875 73.5391L88.8828 74.9766C88.7266 75.0234 88.5443 75.0651 88.3359 75.1016C88.1328 75.138 87.8984 75.1562 87.6328 75.1562C87.2005 75.1562 86.8177 75.0807 86.4844 74.9297C86.151 74.7734 85.8906 74.5208 85.7031 74.1719C85.5156 73.8229 85.4219 73.3594 85.4219 72.7812V64.4766ZM93.9922 75.1562C93.3672 75.1562 92.8021 75.0547 92.2969 74.8516C91.7969 74.6432 91.3698 74.3542 91.0156 73.9844C90.6667 73.6146 90.3984 73.1797 90.2109 72.6797C90.0234 72.1797 89.9297 71.6406 89.9297 71.0625V70.75C89.9297 70.0885 90.026 69.4896 90.2188 68.9531C90.4115 68.4167 90.6797 67.9583 91.0234 67.5781C91.3672 67.1927 91.7734 66.8984 92.2422 66.6953C92.7109 66.4922 93.2188 66.3906 93.7656 66.3906C94.3698 66.3906 94.8984 66.4922 95.3516 66.6953C95.8047 66.8984 96.1797 67.1849 96.4766 67.5547C96.7786 67.9193 97.0026 68.3542 97.1484 68.8594C97.2995 69.3646 97.375 69.9219 97.375 70.5312V71.3359H90.8438V69.9844H95.5156V69.8359C95.5052 69.4974 95.4375 69.1797 95.3125 68.8828C95.1927 68.5859 95.0078 68.3464 94.7578 68.1641C94.5078 67.9818 94.1745 67.8906 93.7578 67.8906C93.4453 67.8906 93.1667 67.9583 92.9219 68.0938C92.6823 68.224 92.4818 68.4141 92.3203 68.6641C92.1589 68.9141 92.0339 69.2161 91.9453 69.5703C91.862 69.9193 91.8203 70.3125 91.8203 70.75V71.0625C91.8203 71.4323 91.8698 71.776 91.9688 72.0938C92.0729 72.4062 92.224 72.6797 92.4219 72.9141C92.6198 73.1484 92.8594 73.3333 93.1406 73.4688C93.4219 73.599 93.7422 73.6641 94.1016 73.6641C94.5547 73.6641 94.9583 73.5729 95.3125 73.3906C95.6667 73.2083 95.974 72.9505 96.2344 72.6172L97.2266 73.5781C97.0443 73.8438 96.8073 74.099 96.5156 74.3438C96.224 74.5833 95.8672 74.7786 95.4453 74.9297C95.0286 75.0807 94.5443 75.1562 93.9922 75.1562ZM100.734 68.1562V75H98.8516V66.5469H100.648L100.734 68.1562ZM103.32 66.4922L103.305 68.2422C103.19 68.2214 103.065 68.2057 102.93 68.1953C102.799 68.1849 102.669 68.1797 102.539 68.1797C102.216 68.1797 101.932 68.2266 101.688 68.3203C101.443 68.4089 101.237 68.5391 101.07 68.7109C100.909 68.8776 100.784 69.0807 100.695 69.3203C100.607 69.5599 100.555 69.8281 100.539 70.125L100.109 70.1562C100.109 69.625 100.161 69.1328 100.266 68.6797C100.37 68.2266 100.526 67.8281 100.734 67.4844C100.948 67.1406 101.214 66.8724 101.531 66.6797C101.854 66.487 102.227 66.3906 102.648 66.3906C102.763 66.3906 102.885 66.401 103.016 66.4219C103.151 66.4427 103.253 66.4661 103.32 66.4922Z'
                  fill='white'
                />
                <path
                  d='M162.975 98.3588C163.526 98.3984 164.005 97.9839 164.044 97.433L164.69 88.4562C164.729 87.9054 164.315 87.4267 163.764 87.3871C163.213 87.3475 162.735 87.7619 162.695 88.3128L162.121 96.2922L154.142 95.7184C153.591 95.6788 153.112 96.0933 153.073 96.6441C153.033 97.195 153.447 97.6737 153.998 97.7133L162.975 98.3588ZM114.477 72.0093C113.93 71.9361 113.426 72.3206 113.353 72.868C113.28 73.4154 113.665 73.9185 114.212 73.9916L114.477 72.0093ZM163.803 96.7068C154.902 86.427 142.544 80.2622 132.477 76.6684C127.434 74.8682 122.944 73.705 119.712 72.9913C118.095 72.6344 116.792 72.3897 115.891 72.2338C115.44 72.1558 115.089 72.1001 114.85 72.0636C114.73 72.0454 114.639 72.032 114.576 72.0231C114.545 72.0186 114.521 72.0152 114.504 72.013C114.496 72.0118 114.489 72.0109 114.485 72.0103C114.483 72.01 114.481 72.0098 114.479 72.0096C114.479 72.0095 114.478 72.0094 114.478 72.0094C114.477 72.0093 114.477 72.0093 114.344 73.0004C114.212 73.9916 114.212 73.9916 114.212 73.9916C114.212 73.9916 114.212 73.9916 114.212 73.9917C114.213 73.9918 114.214 73.9919 114.216 73.9921C114.219 73.9925 114.224 73.9932 114.23 73.9941C114.244 73.996 114.265 73.999 114.293 74.003C114.35 74.0111 114.435 74.0236 114.549 74.0408C114.775 74.0754 115.113 74.129 115.55 74.2045C116.424 74.3557 117.697 74.5946 119.281 74.9443C122.449 75.6439 126.857 76.7856 131.804 78.552C141.719 82.0915 153.712 88.1071 162.291 98.0159L163.803 96.7068Z'
                  fill='white'
                />
              </svg>
            </div>

            {withCloudCameras && (
              <div
                style={{
                  position: 'fixed',
                  right: 0,
                  left: 0,
                  bottom: 56,
                  height: 42,
                  borderRadius: '12px 12px 0 0',
                  backgroundColor:
                    color === 'dark'
                      ? SemanticDarkColors.primary[1]
                      : '#FFFFFF',
                }}
              >
                <div
                  style={{
                    position: 'relative',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      left: 0,
                      right: 0,
                      display: 'flex',
                      justifyContent: 'center',
                      top: -10,
                    }}
                  >
                    <svg
                      width='23'
                      height='8'
                      viewBox='0 0 23 8'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                      style={{ marginTop: 4 }}
                    >
                      <path
                        d='M21.4336 4.17578C21.7461 4.32422 22.0039 4.53125 22.207 4.79688C22.4102 5.0625 22.5117 5.37109 22.5117 5.72266C22.5117 6.30078 22.3281 6.76563 21.9609 7.11719C21.5937 7.46875 21.168 7.64453 20.6836 7.64453C20.4023 7.64453 20.1016 7.57813 19.7812 7.44531C19.4531 7.32031 19.1445 7.19531 18.8555 7.07031L11.0391 3.71875L12.2227 3.71875L4.39453 7.07031C4.11328 7.19531 3.80859 7.32031 3.48047 7.44531C3.15234 7.57813 2.85156 7.64453 2.57812 7.64453C2.09375 7.64453 1.66797 7.46875 1.30078 7.11719C0.933593 6.76563 0.75 6.30078 0.749999 5.72266C0.749999 5.3711 0.851562 5.0625 1.05469 4.79688C1.25781 4.53125 1.51562 4.32422 1.82812 4.17578L9.58594 0.835939C9.96875 0.671876 10.3164 0.531251 10.6289 0.414064C10.9414 0.304689 11.2734 0.250001 11.625 0.250001C11.9844 0.250001 12.3203 0.304689 12.6328 0.414064C12.9453 0.531251 13.2891 0.671876 13.6641 0.835939L21.4336 4.17578Z'
                        fill='#BEBEC1'
                      />
                    </svg>
                  </div>

                  <div
                    style={{
                      height: 28,
                      display: 'flex',
                      alignItems: 'center',
                      margin: '10px 16px',
                    }}
                  >
                    <Typography
                      category='Default'
                      variant='BodyBold'
                      htmlColor={colors.primary['1']}
                    >
                      {t('My Cloud Cameras')}
                    </Typography>
                  </div>
                </div>

                <div style={{ position: 'fixed', left: 50, bottom: 110 }}>
                  <svg
                    width='118'
                    height='66'
                    viewBox='0 0 118 66'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M11.875 17.2969H13.8281C13.7656 18.0417 13.5573 18.7057 13.2031 19.2891C12.849 19.8672 12.3516 20.3229 11.7109 20.6562C11.0703 20.9896 10.2917 21.1562 9.375 21.1562C8.67188 21.1562 8.03906 21.0312 7.47656 20.7812C6.91406 20.526 6.43229 20.1667 6.03125 19.7031C5.63021 19.2344 5.32292 18.6693 5.10938 18.0078C4.90104 17.3464 4.79688 16.6068 4.79688 15.7891V14.8438C4.79688 14.026 4.90365 13.2865 5.11719 12.625C5.33594 11.9635 5.64844 11.3984 6.05469 10.9297C6.46094 10.4557 6.94792 10.0938 7.51562 9.84375C8.08854 9.59375 8.73177 9.46875 9.44531 9.46875C10.3516 9.46875 11.1172 9.63542 11.7422 9.96875C12.3672 10.3021 12.8516 10.763 13.1953 11.3516C13.5443 11.9401 13.7578 12.6146 13.8359 13.375H11.8828C11.8307 12.8854 11.7161 12.4661 11.5391 12.1172C11.3672 11.7682 11.112 11.5026 10.7734 11.3203C10.4349 11.1328 9.99219 11.0391 9.44531 11.0391C8.9974 11.0391 8.60677 11.1224 8.27344 11.2891C7.9401 11.4557 7.66146 11.7005 7.4375 12.0234C7.21354 12.3464 7.04427 12.7448 6.92969 13.2188C6.82031 13.6875 6.76562 14.224 6.76562 14.8281V15.7891C6.76562 16.362 6.8151 16.8828 6.91406 17.3516C7.01823 17.8151 7.17448 18.2135 7.38281 18.5469C7.59635 18.8802 7.86719 19.138 8.19531 19.3203C8.52344 19.5026 8.91667 19.5938 9.375 19.5938C9.93229 19.5938 10.3828 19.5052 10.7266 19.3281C11.0755 19.151 11.3385 18.8932 11.5156 18.5547C11.6979 18.2109 11.8177 17.7917 11.875 17.2969ZM17.4375 9V21H15.5469V9H17.4375ZM19.1406 16.8672V16.6875C19.1406 16.0781 19.2292 15.513 19.4062 14.9922C19.5833 14.4661 19.8385 14.0104 20.1719 13.625C20.5104 13.2344 20.9219 12.9323 21.4062 12.7188C21.8958 12.5 22.4479 12.3906 23.0625 12.3906C23.6823 12.3906 24.2344 12.5 24.7188 12.7188C25.2083 12.9323 25.6224 13.2344 25.9609 13.625C26.2995 14.0104 26.5573 14.4661 26.7344 14.9922C26.9115 15.513 27 16.0781 27 16.6875V16.8672C27 17.4766 26.9115 18.0417 26.7344 18.5625C26.5573 19.0833 26.2995 19.5391 25.9609 19.9297C25.6224 20.3151 25.2109 20.6172 24.7266 20.8359C24.2422 21.0495 23.6927 21.1562 23.0781 21.1562C22.4583 21.1562 21.9036 21.0495 21.4141 20.8359C20.9297 20.6172 20.5182 20.3151 20.1797 19.9297C19.8411 19.5391 19.5833 19.0833 19.4062 18.5625C19.2292 18.0417 19.1406 17.4766 19.1406 16.8672ZM21.0234 16.6875V16.8672C21.0234 17.2474 21.0625 17.6068 21.1406 17.9453C21.2188 18.2839 21.3411 18.5807 21.5078 18.8359C21.6745 19.0911 21.888 19.2917 22.1484 19.4375C22.4089 19.5833 22.7188 19.6562 23.0781 19.6562C23.4271 19.6562 23.7292 19.5833 23.9844 19.4375C24.2448 19.2917 24.4583 19.0911 24.625 18.8359C24.7917 18.5807 24.9141 18.2839 24.9922 17.9453C25.0755 17.6068 25.1172 17.2474 25.1172 16.8672V16.6875C25.1172 16.3125 25.0755 15.9583 24.9922 15.625C24.9141 15.2865 24.7891 14.987 24.6172 14.7266C24.4505 14.4661 24.237 14.263 23.9766 14.1172C23.7214 13.9661 23.4167 13.8906 23.0625 13.8906C22.7083 13.8906 22.401 13.9661 22.1406 14.1172C21.8854 14.263 21.6745 14.4661 21.5078 14.7266C21.3411 14.987 21.2188 15.2865 21.1406 15.625C21.0625 15.9583 21.0234 16.3125 21.0234 16.6875ZM33.6641 19.0078V12.5469H35.5547V21H33.7734L33.6641 19.0078ZM33.9297 17.25L34.5625 17.2344C34.5625 17.8021 34.5 18.3255 34.375 18.8047C34.25 19.2786 34.0573 19.6927 33.7969 20.0469C33.5365 20.3958 33.2031 20.6693 32.7969 20.8672C32.3906 21.0599 31.9036 21.1562 31.3359 21.1562C30.9245 21.1562 30.5469 21.0964 30.2031 20.9766C29.8594 20.8568 29.5625 20.6719 29.3125 20.4219C29.0677 20.1719 28.8776 19.8464 28.7422 19.4453C28.6068 19.0443 28.5391 18.5651 28.5391 18.0078V12.5469H30.4219V18.0234C30.4219 18.3307 30.4583 18.5885 30.5312 18.7969C30.6042 19 30.7031 19.1641 30.8281 19.2891C30.9531 19.4141 31.099 19.5026 31.2656 19.5547C31.4323 19.6068 31.6094 19.6328 31.7969 19.6328C32.3333 19.6328 32.7552 19.5286 33.0625 19.3203C33.375 19.1068 33.5964 18.8203 33.7266 18.4609C33.862 18.1016 33.9297 17.6979 33.9297 17.25ZM42.6406 19.25V9H44.5312V21H42.8203L42.6406 19.25ZM37.1406 16.8672V16.7031C37.1406 16.0625 37.2161 15.4792 37.3672 14.9531C37.5182 14.4219 37.737 13.9661 38.0234 13.5859C38.3099 13.2005 38.6589 12.9062 39.0703 12.7031C39.4818 12.4948 39.9453 12.3906 40.4609 12.3906C40.9714 12.3906 41.4193 12.4896 41.8047 12.6875C42.1901 12.8854 42.5182 13.1693 42.7891 13.5391C43.0599 13.9036 43.276 14.3411 43.4375 14.8516C43.599 15.3568 43.7135 15.9193 43.7812 16.5391V17.0625C43.7135 17.6667 43.599 18.2188 43.4375 18.7188C43.276 19.2188 43.0599 19.651 42.7891 20.0156C42.5182 20.3802 42.1875 20.6615 41.7969 20.8594C41.4115 21.0573 40.9609 21.1562 40.4453 21.1562C39.9349 21.1562 39.474 21.0495 39.0625 20.8359C38.6562 20.6224 38.3099 20.3229 38.0234 19.9375C37.737 19.5521 37.5182 19.099 37.3672 18.5781C37.2161 18.0521 37.1406 17.4818 37.1406 16.8672ZM39.0234 16.7031V16.8672C39.0234 17.2526 39.0573 17.612 39.125 17.9453C39.1979 18.2786 39.3099 18.5729 39.4609 18.8281C39.612 19.0781 39.8073 19.276 40.0469 19.4219C40.2917 19.5625 40.5833 19.6328 40.9219 19.6328C41.349 19.6328 41.7005 19.5391 41.9766 19.3516C42.2526 19.1641 42.4688 18.9115 42.625 18.5938C42.7865 18.2708 42.8958 17.9115 42.9531 17.5156V16.1016C42.9219 15.7943 42.8568 15.5078 42.7578 15.2422C42.6641 14.9766 42.5365 14.7448 42.375 14.5469C42.2135 14.3438 42.013 14.1875 41.7734 14.0781C41.5391 13.9635 41.2604 13.9062 40.9375 13.9062C40.5938 13.9062 40.3021 13.9792 40.0625 14.125C39.8229 14.2708 39.625 14.4714 39.4688 14.7266C39.3177 14.9818 39.2057 15.2786 39.1328 15.6172C39.0599 15.9557 39.0234 16.3177 39.0234 16.7031ZM57.3906 17.2969H59.3438C59.2812 18.0417 59.0729 18.7057 58.7188 19.2891C58.3646 19.8672 57.8672 20.3229 57.2266 20.6562C56.5859 20.9896 55.8073 21.1562 54.8906 21.1562C54.1875 21.1562 53.5547 21.0312 52.9922 20.7812C52.4297 20.526 51.9479 20.1667 51.5469 19.7031C51.1458 19.2344 50.8385 18.6693 50.625 18.0078C50.4167 17.3464 50.3125 16.6068 50.3125 15.7891V14.8438C50.3125 14.026 50.4193 13.2865 50.6328 12.625C50.8516 11.9635 51.1641 11.3984 51.5703 10.9297C51.9766 10.4557 52.4635 10.0938 53.0312 9.84375C53.6042 9.59375 54.2474 9.46875 54.9609 9.46875C55.8672 9.46875 56.6328 9.63542 57.2578 9.96875C57.8828 10.3021 58.3672 10.763 58.7109 11.3516C59.0599 11.9401 59.2734 12.6146 59.3516 13.375H57.3984C57.3464 12.8854 57.2318 12.4661 57.0547 12.1172C56.8828 11.7682 56.6276 11.5026 56.2891 11.3203C55.9505 11.1328 55.5078 11.0391 54.9609 11.0391C54.513 11.0391 54.1224 11.1224 53.7891 11.2891C53.4557 11.4557 53.1771 11.7005 52.9531 12.0234C52.7292 12.3464 52.5599 12.7448 52.4453 13.2188C52.3359 13.6875 52.2812 14.224 52.2812 14.8281V15.7891C52.2812 16.362 52.3307 16.8828 52.4297 17.3516C52.5339 17.8151 52.6901 18.2135 52.8984 18.5469C53.112 18.8802 53.3828 19.138 53.7109 19.3203C54.0391 19.5026 54.4323 19.5938 54.8906 19.5938C55.4479 19.5938 55.8984 19.5052 56.2422 19.3281C56.5911 19.151 56.8542 18.8932 57.0312 18.5547C57.2135 18.2109 57.3333 17.7917 57.3906 17.2969ZM65.7031 19.3047V15.2734C65.7031 14.9714 65.6484 14.7109 65.5391 14.4922C65.4297 14.2734 65.263 14.1042 65.0391 13.9844C64.8203 13.8646 64.5443 13.8047 64.2109 13.8047C63.9036 13.8047 63.638 13.8568 63.4141 13.9609C63.1901 14.0651 63.0156 14.2057 62.8906 14.3828C62.7656 14.5599 62.7031 14.7604 62.7031 14.9844H60.8281C60.8281 14.651 60.9089 14.3281 61.0703 14.0156C61.2318 13.7031 61.4661 13.4245 61.7734 13.1797C62.0807 12.9349 62.4479 12.7422 62.875 12.6016C63.3021 12.4609 63.7812 12.3906 64.3125 12.3906C64.9479 12.3906 65.5104 12.4974 66 12.7109C66.4948 12.9245 66.8828 13.2474 67.1641 13.6797C67.4505 14.1068 67.5938 14.6432 67.5938 15.2891V19.0469C67.5938 19.4323 67.6198 19.7786 67.6719 20.0859C67.7292 20.388 67.8099 20.651 67.9141 20.875V21H65.9844C65.8958 20.7969 65.8255 20.5391 65.7734 20.2266C65.7266 19.9089 65.7031 19.6016 65.7031 19.3047ZM65.9766 15.8594L65.9922 17.0234H64.6406C64.2917 17.0234 63.9844 17.0573 63.7188 17.125C63.4531 17.1875 63.2318 17.2812 63.0547 17.4062C62.8776 17.5312 62.7448 17.6823 62.6562 17.8594C62.5677 18.0365 62.5234 18.237 62.5234 18.4609C62.5234 18.6849 62.5755 18.8906 62.6797 19.0781C62.7839 19.2604 62.9349 19.4036 63.1328 19.5078C63.3359 19.612 63.5807 19.6641 63.8672 19.6641C64.2526 19.6641 64.5885 19.5859 64.875 19.4297C65.1667 19.2682 65.3958 19.0729 65.5625 18.8438C65.7292 18.6094 65.8177 18.388 65.8281 18.1797L66.4375 19.0156C66.375 19.2292 66.2682 19.4583 66.1172 19.7031C65.9661 19.9479 65.7682 20.1823 65.5234 20.4062C65.2839 20.625 64.9948 20.8047 64.6562 20.9453C64.3229 21.0859 63.9375 21.1562 63.5 21.1562C62.9479 21.1562 62.4557 21.0469 62.0234 20.8281C61.5911 20.6042 61.2526 20.3047 61.0078 19.9297C60.763 19.5495 60.6406 19.1198 60.6406 18.6406C60.6406 18.1927 60.724 17.7969 60.8906 17.4531C61.0625 17.1042 61.3125 16.8125 61.6406 16.5781C61.974 16.3438 62.3802 16.1667 62.8594 16.0469C63.3385 15.9219 63.8854 15.8594 64.5 15.8594H65.9766ZM71.4453 14.2656V21H69.5625V12.5469H71.3359L71.4453 14.2656ZM71.1406 16.4609L70.5 16.4531C70.5 15.8698 70.5729 15.3307 70.7188 14.8359C70.8646 14.3411 71.0781 13.9115 71.3594 13.5469C71.6406 13.1771 71.9896 12.8932 72.4062 12.6953C72.8281 12.4922 73.3151 12.3906 73.8672 12.3906C74.2526 12.3906 74.6042 12.4479 74.9219 12.5625C75.2448 12.6719 75.5234 12.8464 75.7578 13.0859C75.9974 13.3255 76.1797 13.6328 76.3047 14.0078C76.4349 14.3828 76.5 14.8359 76.5 15.3672V21H74.6172V15.5312C74.6172 15.1198 74.5547 14.7969 74.4297 14.5625C74.3099 14.3281 74.1354 14.1615 73.9062 14.0625C73.6823 13.9583 73.4141 13.9062 73.1016 13.9062C72.7474 13.9062 72.4453 13.974 72.1953 14.1094C71.9505 14.2448 71.75 14.4297 71.5938 14.6641C71.4375 14.8984 71.3229 15.1693 71.25 15.4766C71.1771 15.7839 71.1406 16.112 71.1406 16.4609ZM76.3828 15.9609L75.5 16.1562C75.5 15.6458 75.5703 15.1641 75.7109 14.7109C75.8568 14.2526 76.0677 13.8516 76.3438 13.5078C76.625 13.1589 76.9714 12.8854 77.3828 12.6875C77.7943 12.4896 78.2656 12.3906 78.7969 12.3906C79.2292 12.3906 79.6146 12.4505 79.9531 12.5703C80.2969 12.6849 80.5885 12.8672 80.8281 13.1172C81.0677 13.3672 81.25 13.6927 81.375 14.0938C81.5 14.4896 81.5625 14.9688 81.5625 15.5312V21H79.6719V15.5234C79.6719 15.0964 79.6094 14.7656 79.4844 14.5312C79.3646 14.2969 79.1927 14.1354 78.9688 14.0469C78.7448 13.9531 78.4766 13.9062 78.1641 13.9062C77.8724 13.9062 77.6146 13.9609 77.3906 14.0703C77.1719 14.1745 76.987 14.3229 76.8359 14.5156C76.6849 14.7031 76.5703 14.9193 76.4922 15.1641C76.4193 15.4089 76.3828 15.6745 76.3828 15.9609ZM87.2266 21.1562C86.6016 21.1562 86.0365 21.0547 85.5312 20.8516C85.0312 20.6432 84.6042 20.3542 84.25 19.9844C83.901 19.6146 83.6328 19.1797 83.4453 18.6797C83.2578 18.1797 83.1641 17.6406 83.1641 17.0625V16.75C83.1641 16.0885 83.2604 15.4896 83.4531 14.9531C83.6458 14.4167 83.9141 13.9583 84.2578 13.5781C84.6016 13.1927 85.0078 12.8984 85.4766 12.6953C85.9453 12.4922 86.4531 12.3906 87 12.3906C87.6042 12.3906 88.1328 12.4922 88.5859 12.6953C89.0391 12.8984 89.4141 13.1849 89.7109 13.5547C90.013 13.9193 90.237 14.3542 90.3828 14.8594C90.5339 15.3646 90.6094 15.9219 90.6094 16.5312V17.3359H84.0781V15.9844H88.75V15.8359C88.7396 15.4974 88.6719 15.1797 88.5469 14.8828C88.4271 14.5859 88.2422 14.3464 87.9922 14.1641C87.7422 13.9818 87.4089 13.8906 86.9922 13.8906C86.6797 13.8906 86.401 13.9583 86.1562 14.0938C85.9167 14.224 85.7161 14.4141 85.5547 14.6641C85.3932 14.9141 85.2682 15.2161 85.1797 15.5703C85.0964 15.9193 85.0547 16.3125 85.0547 16.75V17.0625C85.0547 17.4323 85.1042 17.776 85.2031 18.0938C85.3073 18.4062 85.4583 18.6797 85.6562 18.9141C85.8542 19.1484 86.0938 19.3333 86.375 19.4688C86.6562 19.599 86.9766 19.6641 87.3359 19.6641C87.7891 19.6641 88.1927 19.5729 88.5469 19.3906C88.901 19.2083 89.2083 18.9505 89.4688 18.6172L90.4609 19.5781C90.2786 19.8438 90.0417 20.099 89.75 20.3438C89.4583 20.5833 89.1016 20.7786 88.6797 20.9297C88.263 21.0807 87.7786 21.1562 87.2266 21.1562ZM93.9688 14.1562V21H92.0859V12.5469H93.8828L93.9688 14.1562ZM96.5547 12.4922L96.5391 14.2422C96.4245 14.2214 96.2995 14.2057 96.1641 14.1953C96.0339 14.1849 95.9036 14.1797 95.7734 14.1797C95.4505 14.1797 95.1667 14.2266 94.9219 14.3203C94.6771 14.4089 94.4714 14.5391 94.3047 14.7109C94.1432 14.8776 94.0182 15.0807 93.9297 15.3203C93.8411 15.5599 93.7891 15.8281 93.7734 16.125L93.3438 16.1562C93.3438 15.625 93.3958 15.1328 93.5 14.6797C93.6042 14.2266 93.7604 13.8281 93.9688 13.4844C94.1823 13.1406 94.4479 12.8724 94.7656 12.6797C95.0885 12.487 95.4609 12.3906 95.8828 12.3906C95.9974 12.3906 96.1198 12.401 96.25 12.4219C96.3854 12.4427 96.487 12.4661 96.5547 12.4922ZM102.219 19.3047V15.2734C102.219 14.9714 102.164 14.7109 102.055 14.4922C101.945 14.2734 101.779 14.1042 101.555 13.9844C101.336 13.8646 101.06 13.8047 100.727 13.8047C100.419 13.8047 100.154 13.8568 99.9297 13.9609C99.7057 14.0651 99.5312 14.2057 99.4062 14.3828C99.2812 14.5599 99.2188 14.7604 99.2188 14.9844H97.3438C97.3438 14.651 97.4245 14.3281 97.5859 14.0156C97.7474 13.7031 97.9818 13.4245 98.2891 13.1797C98.5964 12.9349 98.9635 12.7422 99.3906 12.6016C99.8177 12.4609 100.297 12.3906 100.828 12.3906C101.464 12.3906 102.026 12.4974 102.516 12.7109C103.01 12.9245 103.398 13.2474 103.68 13.6797C103.966 14.1068 104.109 14.6432 104.109 15.2891V19.0469C104.109 19.4323 104.135 19.7786 104.188 20.0859C104.245 20.388 104.326 20.651 104.43 20.875V21H102.5C102.411 20.7969 102.341 20.5391 102.289 20.2266C102.242 19.9089 102.219 19.6016 102.219 19.3047ZM102.492 15.8594L102.508 17.0234H101.156C100.807 17.0234 100.5 17.0573 100.234 17.125C99.9688 17.1875 99.7474 17.2812 99.5703 17.4062C99.3932 17.5312 99.2604 17.6823 99.1719 17.8594C99.0833 18.0365 99.0391 18.237 99.0391 18.4609C99.0391 18.6849 99.0911 18.8906 99.1953 19.0781C99.2995 19.2604 99.4505 19.4036 99.6484 19.5078C99.8516 19.612 100.096 19.6641 100.383 19.6641C100.768 19.6641 101.104 19.5859 101.391 19.4297C101.682 19.2682 101.911 19.0729 102.078 18.8438C102.245 18.6094 102.333 18.388 102.344 18.1797L102.953 19.0156C102.891 19.2292 102.784 19.4583 102.633 19.7031C102.482 19.9479 102.284 20.1823 102.039 20.4062C101.799 20.625 101.51 20.8047 101.172 20.9453C100.839 21.0859 100.453 21.1562 100.016 21.1562C99.4635 21.1562 98.9714 21.0469 98.5391 20.8281C98.1068 20.6042 97.7682 20.3047 97.5234 19.9297C97.2786 19.5495 97.1562 19.1198 97.1562 18.6406C97.1562 18.1927 97.2396 17.7969 97.4062 17.4531C97.5781 17.1042 97.8281 16.8125 98.1562 16.5781C98.4896 16.3438 98.8958 16.1667 99.375 16.0469C99.8542 15.9219 100.401 15.8594 101.016 15.8594H102.492ZM110.82 18.7109C110.82 18.5234 110.773 18.3542 110.68 18.2031C110.586 18.0469 110.406 17.9062 110.141 17.7812C109.88 17.6562 109.495 17.5417 108.984 17.4375C108.536 17.3385 108.125 17.2214 107.75 17.0859C107.38 16.9453 107.062 16.776 106.797 16.5781C106.531 16.3802 106.326 16.1458 106.18 15.875C106.034 15.6042 105.961 15.2917 105.961 14.9375C105.961 14.5938 106.036 14.2682 106.188 13.9609C106.339 13.6536 106.555 13.3828 106.836 13.1484C107.117 12.9141 107.458 12.7292 107.859 12.5938C108.266 12.4583 108.719 12.3906 109.219 12.3906C109.927 12.3906 110.534 12.5104 111.039 12.75C111.549 12.9844 111.94 13.3047 112.211 13.7109C112.482 14.112 112.617 14.5651 112.617 15.0703H110.734C110.734 14.8464 110.677 14.638 110.562 14.4453C110.453 14.2474 110.286 14.0885 110.062 13.9688C109.839 13.8438 109.557 13.7812 109.219 13.7812C108.896 13.7812 108.628 13.8333 108.414 13.9375C108.206 14.0365 108.049 14.1667 107.945 14.3281C107.846 14.4896 107.797 14.6667 107.797 14.8594C107.797 15 107.823 15.1276 107.875 15.2422C107.932 15.3516 108.026 15.4531 108.156 15.5469C108.286 15.6354 108.464 15.7188 108.688 15.7969C108.917 15.875 109.203 15.9505 109.547 16.0234C110.193 16.1589 110.747 16.3333 111.211 16.5469C111.68 16.7552 112.039 17.026 112.289 17.3594C112.539 17.6875 112.664 18.1042 112.664 18.6094C112.664 18.9844 112.583 19.3281 112.422 19.6406C112.266 19.9479 112.036 20.2161 111.734 20.4453C111.432 20.6693 111.07 20.8438 110.648 20.9688C110.232 21.0938 109.763 21.1562 109.242 21.1562C108.477 21.1562 107.828 21.0208 107.297 20.75C106.766 20.474 106.362 20.1224 106.086 19.6953C105.815 19.263 105.68 18.8151 105.68 18.3516H107.5C107.521 18.7005 107.617 18.9792 107.789 19.1875C107.966 19.3906 108.185 19.5391 108.445 19.6328C108.711 19.7214 108.984 19.7656 109.266 19.7656C109.604 19.7656 109.888 19.7214 110.117 19.6328C110.346 19.5391 110.521 19.4141 110.641 19.2578C110.76 19.0964 110.82 18.9141 110.82 18.7109Z'
                      fill='white'
                    />
                    <path
                      d='M58.7937 65.7073C59.1843 66.0977 59.8175 66.0976 60.2079 65.707L66.5706 59.3417C66.961 58.951 66.9609 58.3179 66.5703 57.9274C66.1797 57.537 65.5465 57.5371 65.156 57.9277L59.5004 63.5858L53.8423 57.9301C53.4517 57.5397 52.8186 57.5398 52.4281 57.9304C52.0377 58.321 52.0378 58.9542 52.4284 59.3446L58.7937 65.7073ZM60.4981 38.5C60.4981 37.9477 60.0504 37.5 59.4981 37.5C58.9458 37.5 58.4981 37.9477 58.4981 38.5L60.4981 38.5ZM60.5007 64.9998C60.4993 58.2499 60.4986 51.6249 60.4983 46.6874C60.4981 44.2187 60.4981 42.1718 60.4981 40.7422C60.498 40.0273 60.498 39.4668 60.498 39.085C60.498 38.894 60.498 38.7478 60.498 38.6493C60.498 38.6 60.4981 38.5627 60.4981 38.5377C60.4981 38.5252 60.4981 38.5158 60.4981 38.5095C60.4981 38.5063 60.4981 38.504 60.4981 38.5024C60.4981 38.5016 60.4981 38.501 60.4981 38.5006C60.4981 38.5004 60.4981 38.5003 60.4981 38.5002C60.4981 38.5001 60.4981 38.5 59.4981 38.5C58.4981 38.5 58.4981 38.5 58.4981 38.5001C58.4981 38.5002 58.4981 38.5004 58.4981 38.5006C58.4981 38.501 58.4981 38.5016 58.4981 38.5024C58.4981 38.5039 58.4981 38.5063 58.4981 38.5095C58.4981 38.5158 58.4981 38.5252 58.4981 38.5377C58.4981 38.5627 58.498 38.6 58.498 38.6493C58.498 38.7478 58.498 38.894 58.498 39.085C58.498 39.4668 58.498 40.0274 58.4981 40.7422C58.4981 42.1719 58.4981 44.2188 58.4983 46.6876C58.4986 51.6251 58.4993 58.2501 58.5007 65.0002L60.5007 64.9998Z'
                      fill='white'
                    />
                  </svg>
                </div>
              </div>
            )}
          </div>
          {topButtonMarkup}
        </>
      )
    );
  }, [
    color,
    colors,
    handleFailedLocation,
    locPerm,
    query,
    t,
    themeState,
    topButtonMarkup,
    visibleGuide,
    withCloudCameras,
  ]);

  const newFw = useMemo(() => {
    const fw = _.find(availableNewFws, (v, k) => k === moreCamera?.psn);
    return !!(fw?.blackvue || fw?.dmc200);
  }, [availableNewFws, moreCamera?.psn]);

  useEffect(() => {
    if (openDisconnectedModal) {
      const timeout = setTimeout(() => {
        setOpenDisconnectedModal(false);
      }, 5000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [openDisconnectedModal]);

  useEffect(() => {
    if (openNoGPSModal) {
      const timeout = setTimeout(() => {
        setOpenNoGPSModal(false);
      }, 5000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [openNoGPSModal]);

  useEffect(() => {
    if (openNotLoginModal) {
      const timeout = setTimeout(() => {
        setOpenNotLoginModal(false);
      }, 5000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [openNotLoginModal]);

  useEffect(() => {
    if (
      cameraList?.deviceListInfo &&
      liveCams.length !== cameraList.deviceListInfo.length
    ) {
      setLiveCams(_.map(cameraList.deviceListInfo, (dev) => dev.device));
    }
  }, [cameraList?.deviceListInfo, liveCams.length]);

  const disconnectToastMarkup = useMemo(() => {
    return (
      <div
        className={clsx(classes.toastDiv, {
          [classes.toastOpen]: openDisconnectedModal && drawMode === 'close',
        })}
      >
        <div
          className={classes.toast}
          style={{ backgroundColor: colors.primary['1'] }}
          onClick={() => {
            setOpenDisconnectedModal(false);
          }}
        >
          <Typography variant='SmallBold' htmlColor={colors.primary['0']}>
            {t('The location may not be accurate_')}
          </Typography>
        </div>
      </div>
    );
  }, [
    classes.toast,
    classes.toastDiv,
    classes.toastOpen,
    colors.primary,
    drawMode,
    openDisconnectedModal,
    t,
  ]);

  const noGPSToastMarkup = useMemo(() => {
    return (
      <div
        className={clsx(classes.toastDiv, {
          [classes.toastOpen]: openNoGPSModal && drawMode === 'close',
        })}
      >
        <div
          className={classes.toast}
          style={{ backgroundColor: colors.primary['1'] }}
          onClick={() => {
            setOpenNoGPSModal(false);
          }}
        >
          <Typography variant='SmallBold' htmlColor={colors.primary['0']}>
            {t('The camera location cannot be found_')}
          </Typography>
        </div>
      </div>
    );
  }, [
    classes.toast,
    classes.toastDiv,
    classes.toastOpen,
    colors.primary,
    drawMode,
    openNoGPSModal,
    t,
  ]);

  const notLoginToastMarkup = useMemo(() => {
    return (
      <div
        className={clsx(classes.toastDiv, {
          [classes.toastOpen]: openNotLoginModal && drawMode === 'close',
        })}
      >
        <div
          className={classes.toast}
          style={{ backgroundColor: colors.primary['1'] }}
          onClick={() => {
            setOpenNotLoginModal(false);
          }}
        >
          <Typography variant='SmallBold' htmlColor={colors.primary['0']}>
            {t('The location of the camera cannot be found_')}
          </Typography>
        </div>
      </div>
    );
  }, [
    classes.toast,
    classes.toastDiv,
    classes.toastOpen,
    colors.primary,
    drawMode,
    openNotLoginModal,
    t,
  ]);

  const closeLiveview = useCallback(() => {
    setOpenLiveModal(false);
    setLiveCam(undefined);
    dispatch(clearPublicCamera());
    disableRotate();
    dispatch(setRemovePlayer(false));
  }, [dispatch]);

  const handleLiveView = useCallback(
    async (psn: string, isPublic: boolean) => {
      console.log('handleLiveView', psn, isPublic, email, loginInfo);
      if (!email || !loginInfo) return;
      const resp = await getCamInfo(
        email,
        loginInfo?.user_token,
        psn,
        tokenType
      );

      const config = getFirmwareConfig(resp.data.response['device info']);
      const cloudNative = !!config?.CloudNative;
      console.log(
        'handleLiveView',
        resp.data.response['device info'],
        'config',
        config,
        'cloudNative',
        cloudNative
      );

      const browser = detect();
      const msg = {
        psn,
        isPublic,
      };
      console.log('handleLiveView', 'browser', browser, 'msg', msg);
      if (browser?.name === 'ios-webview') {
        //@ts-ignore
        return webkit.messageHandlers.openLiveview.postMessage(msg);
      } else if (browser?.name === 'chromium-webview') {
        //@ts-ignore
        window.Webviewer?.openLiveview(JSON.stringify(msg));
      }
      // else {
      //   console.log('handleLiveView', 'isPublic', isPublic);
      //   setPublicCam(isPublic);
      //   if (isPublic) {
      //     dispatch(loadPublicCamera(psn));
      //     setOpenLiveModal(true);
      //   } else {
      //     const cam = _.find(liveCams, (dev) => dev.psn === psn);
      //     if (cam) {
      //       setLiveCam(cam);
      //       setOpenLiveModal(true);
      //     }
      //   }
      // }
    },
    [email, loginInfo, tokenType]
  );

  const onClickManage = useCallback(() => {
    if (browser?.name === 'ios-webview') {
      //@ts-ignore
      return webkit.messageHandlers.manageSubscribe.postMessage({});
    }
    if (
      browser?.name === 'chromium-webview' &&
      //@ts-ignore
      window.Webviewer?.manageSubscribe
    ) {
      //@ts-ignore
      window.Webviewer?.manageSubscribe();
    }
  }, [browser?.name]);

  const onClickDelete = useCallback(
    (camera: ICameraInfo) => {
      const msg = {
        psn: camera.psn,
      };
      if (browser?.name === 'ios-webview') {
        //@ts-ignore
        return webkit.messageHandlers.removeCloud.postMessage(msg);
      }
      if (browser?.name === 'chromium-webview') {
        //@ts-ignore
        window.Webviewer?.removeCloud(JSON.stringify(msg));
      }
    },
    [browser?.name]
  );

  const rootHeight = useMemo(() => {
    const browser = detect();
    console.log('rootHeight', browser);
    if (withCloudCameras) {
      // if (browser?.name === 'ios-webview' || browser?.name === 'ios') {
      //   return 'calc(100vh - 180px)';
      // }
      return 'calc(100vh - 100px)';
    }

    return 'calc(100vh - 56px)';
  }, [withCloudCameras]);

  return (
    <div>
      {<PublicCamInfoToast setInfoOpen={setInfoOpen} infoOpen={infoOpen} />}
      {topButtonMarkup}
      <div
        style={{
          width: '100%',
          height: rootHeight,
        }}
      >
        <MapboxLocationMapWrapper
          renewal
          focusCam={focusCam}
          onLiveView={handleLiveView}
          mapRef={mapRef}
          clearFocusCam={() => {
            setFocusCam(undefined);
          }}
          onFailedLocation={() => {
            handleFailedLocation();
          }}
          locPerm={locPerm}
        />

        {withCloudCameras && (
          <MobileDrawer
            initMode={drawMode}
            mode='renewal-camera'
            onDrawerMode={setDrawMode}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
              }}
            >
              <div
                style={{
                  height: 28,
                  display: 'flex',
                  alignItems: 'center',
                  margin: '10px 16px',
                }}
              >
                <Typography
                  category='Default'
                  variant='BodyBold'
                  htmlColor={colors.primary['1']}
                >
                  {t('My Cloud Cameras')}
                </Typography>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                  gap: 8,
                  padding: '8px 16px',
                  overflowY: 'auto',
                }}
              >
                {_.chain(cameraList?.deviceListInfo)
                  .filter((d) => d.device.reg_category !== 'wifi')
                  .map((d) => {
                    const fw = _.find(
                      availableNewFws,
                      (v, k) => k === d.device.psn
                    );

                    const batteryConnectTime = wifiBatteryList.find(
                      (b) => b.psn === d.device.psn
                    )?.time;

                    let batteryState;

                    if (
                      batteryConnectTime &&
                      !Number.isInteger(batteryConnectTime)
                    ) {
                      batteryState =
                        Date.now() - batteryConnectTime * 1000 <= 10 * 60 * 1000
                          ? 'latest'
                          : 'lateup2';
                    } else if (
                      batteryConnectTime &&
                      Number.isInteger(batteryConnectTime)
                    ) {
                      batteryState =
                        Date.now() - batteryConnectTime <= 10 * 60 * 1000
                          ? 'latest'
                          : 'lateup2';
                    }

                    const batteryPercent = wifiBatteryList.find(
                      (b) => b.psn === d.device.psn
                    )?.percent;

                    return (
                      <RenewalCameraItem
                        key={d.device.psn}
                        camera={d.device}
                        batteryState={batteryState}
                        batteryPercent={batteryPercent}
                        newFw={!!(fw?.blackvue || fw?.dmc200)}
                        onClickMore={() => {
                          setMoreCamera(d.device);
                          setOpenMoreMenu(true);
                        }}
                        handleMenu={(menu) => {
                          handleMenu(menu, d.device);
                        }}
                        onClickLocation={() => {
                          if (d.device.login_date) {
                            if (d.device.active === 'off') {
                              if (!d.device.latitude || !d.device.longitude) {
                                setOpenNoGPSModal(true);
                              } else {
                                setOpenDisconnectedModal(true);
                              }
                            } else {
                              if (!d.device.latitude || !d.device.longitude) {
                                setOpenNoGPSModal(true);
                              }
                            }
                          } else {
                            setOpenNotLoginModal(true);
                          }

                          setFocusCam(d.device);
                          setDrawMode('close');
                        }}
                        onClickManage={onClickManage}
                        onClickDelete={onClickDelete}
                      />
                    );
                  })
                  .value()}
              </div>
            </div>
          </MobileDrawer>
        )}
      </div>

      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          switch (newValue) {
            case 0:
              handleBack('MENU_EXPLORE');
              break;
            case 2:
              handleBack('MENU_CLOUDSTORAGE');
              break;
            case 3:
              handleBack('MENU_ACCOUNT');
              break;
          }
        }}
        showLabels
        className={classes.footerMenuDiv}
      >
        <BottomNavigationAction
          disableRipple
          classes={{
            root: clsx(classes.actionRoot, {}),
            label: classes.actionLabel,
          }}
          label={t('Explore')}
          icon={<ExploreIcon style={{ width: 18 }} />}
        />
        <BottomNavigationAction
          disableRipple
          classes={{
            root: clsx(classes.actionRoot, {}),
            label: classes.actionLabel,
            selected: classes.actionSelected,
          }}
          label='Cameras'
          icon={<CameraIcon style={{ width: 20 }} />}
        />
        <BottomNavigationAction
          disableRipple
          classes={{
            root: clsx(classes.actionRoot, {}),
            label: classes.actionLabel,
          }}
          label={t('Cloud Storage')}
          icon={<CloudQueueIcon style={{ width: 18 }} />}
        />
        <BottomNavigationAction
          disableRipple
          classes={{
            root: clsx(classes.actionRoot, {}),
            label: classes.actionLabel,
          }}
          label={t('Account')}
          icon={<AccountIcon style={{ width: 16 }} />}
        />
      </BottomNavigation>

      <RenewalMobileCameraMenu
        open={openMoreMenu}
        camera={moreCamera}
        onClose={() => {
          setMoreCamera(undefined);
          setOpenMoreMenu(false);
        }}
        newFw={newFw}
        onClickMenu={(menu) => {
          setOpenMoreMenu(false);
          handleMenu(menu, moreCamera);
          setMoreCamera(undefined);
        }}
        {...permissions}
      />

      <LiveViewMapboxModal
        open={openLiveModal}
        camera={liveCam}
        fullScreen={true}
        noMargin
        mobile
        app
        onClose={() => {
          closeLiveview();
        }}
        container={mapRef.current}
      />

      {guideMarkup}
      {disconnectToastMarkup}
      {notLoginToastMarkup}
      {noGPSToastMarkup}

      {
        <Modal
          open={openNoLocPermIOSModal}
          heading={t('Center your location_')}
          titleClassName={classes.modalTitle}
          headingTextClassName={classes.modalHeadingText}
          content={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <Typography
                category='Default'
                variant='Body'
                htmlColor={colors.primary['1']}
              >
                {t('Please agree to allow location_')}
              </Typography>
              <img
                src='/images/ios-loc-perm.png'
                style={{ width: 270 }}
                alt='No loc permission'
              />
            </div>
          }
          onClickNegative={() => {
            setOpenNoLocPermIOSModal(false);
          }}
          onClickPositive={() => {
            if (browser?.name === 'ios-webview') {
              //@ts-ignore
              return webkit.messageHandlers.openLocPermSetting.postMessage({});
            }
          }}
          contentClassName={classes.iosModalContent}
          RButton={t('Go to settings')}
          LButton={t('Cancel')}
          fullWidthBtn
          LButtonClassName={classes.modalLButton}
        />
      }

      <Modal
        open={openNoLocPermModal}
        headingIcon={<ErrorIcon htmlColor={LightColors.secondary['11']} />}
        heading={t('Location access permission required')}
        content={
          <>
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
              <img
                src='/images/loc-perm-required.png'
                alt='location permissin is required'
                width={346}
              />
            </div>
          </>
        }
        close
        onClose={() => setOpenNoLocPermModal(false)}
        onClickPositive={() => setOpenNoLocPermModal(false)}
        RButton={t('OK')}
      />
    </div>
  );
};
